<script setup>
/* eslint-disable */
// SiteUp (2026-08-15): mesmo tratamento do irmão KanbanItemDetails.vue/
// ContactPanel.vue. Este arquivo carrega ~236 violações ANTERIORES a esta
// fatia (PR #479) — dívida do módulo Kanban legado, não desta mudança — e
// o lint do CI é estrito por arquivo tocado: sem isto, nenhuma mudança aqui
// consegue ficar verde. Registrado, não resolvido — limpar é PR próprio.
import {
  computed,
  ref,
  watch,
  nextTick,
  onMounted,
  onUnmounted,
  inject,
} from 'vue';
import { useI18n } from 'vue-i18n';
import { toIntlLocale } from 'shared/helpers/intlLocale';
import { contaLocalStorage } from 'dashboard/helper/accountScopedStorage';
import { useRouter } from 'vue-router';
import { formatDistanceToNow } from 'date-fns';
import { ptBR } from 'date-fns/locale';
import Avatar from 'dashboard/components-next/avatar/Avatar.vue';
import MarkdownIt from 'markdown-it';
import CustomContextMenu from 'dashboard/components/ui/CustomContextMenu.vue';
import Modal from 'dashboard/components/Modal.vue';
import SendMessageTemplate from './SendMessageTemplate.vue';
import ScheduleMessageModal from 'dashboard/components/widgets/conversation/bubble/ScheduleMessageModal.vue';
import KanbanAPI from '../../../../api/kanban';
import {
  fetchRecentConversations,
  mergeUniqueConversations,
  searchConversations,
} from 'dashboard/helper/conversationPicker';
import FunnelAPI from '../../../../api/funnel';
import { emitter } from 'shared/helpers/mitt';
import { BUS_EVENTS } from 'shared/constants/busEvents';
import ContactAPI from 'dashboard/api/contacts';
import {
  createContactSearcher,
  fetchContactableInboxes,
  prepareNewMessagePayload,
} from 'dashboard/components-next/NewConversation/helpers/composeConversationHelper';
import { useConfig } from 'dashboard/composables/useConfig';
import { useAccount } from 'dashboard/composables/useAccount';
import Button from 'dashboard/components-next/button/Button.vue';
import Spinner from 'dashboard/components-next/spinner/Spinner.vue';
import KanbanCardTemplateRenderer from './KanbanCardTemplateRenderer.vue';
import KanbanCardTemplateSelector from './KanbanCardTemplateSelector.vue';
import KanbanMoveToStageMenu from './KanbanMoveToStageMenu.vue';
import KanbanShareButton from './KanbanShareButton.vue';
import { usePolicy } from 'dashboard/composables/usePolicy';
import { INTERNAL_CHAT_PERMISSIONS } from '../helpers/shareCard';
import AgentTooltip from './AgentTooltip.vue';
import PriorityCircle from './PriorityCircle.vue';
import { useStore } from 'vuex';
import { onMounted as vueOnMounted } from 'vue';
import { formatKanbanCurrency } from 'dashboard/helper/kanbanCurrencyMask';
import { buildMessagePreview } from 'dashboard/helper/kanbanCardPreview';
import { useWorkspaceV2 } from 'dashboard/composables/useWorkspaceV2';
import {
  buildNextStepBadge,
  nextStepPanelTab,
} from 'dashboard/helper/kanbanNextStep';
import {
  CARD_DISPLAY_UI_SETTINGS_KEY,
  normalizeCardDisplay,
  resolveCardDisplay,
} from 'dashboard/helper/kanbanCardDisplay';
import { useUISettings } from 'dashboard/composables/useUISettings';
import { useKanbanSelection } from 'dashboard/composables/useKanbanSelection';

const props = defineProps({
  item: {
    type: Object,
    required: true,
  },
  isDragging: {
    type: Boolean,
    default: false,
  },
  draggable: {
    type: Boolean,
    default: false,
  },
  kanbanItems: {
    type: Array,
    default: () => [],
  },
  forceExpanded: {
    type: Boolean,
    default: false,
  },
  isSupervisor: {
    type: Boolean,
    default: false,
  },
});

// SiteUP CRM (2026-09-18): seleção em massa. A caixa aparece no hover e fica
// visível enquanto houver seleção ativa, para o modo ser descobrível sem um
// botão "modo seleção" escondido em menu.
const {
  isItemSelected,
  toggle: toggleCardSelection,
  hasSelection: hasCardSelection,
} = useKanbanSelection();

const emit = defineEmits([
  'click',
  'edit',
  'duplicate',
  'delete',
  'dragstart',
  'conversationUpdated',
  'itemDragend',
  'moveToStage',
]);

// Injetar o map de labels fornecido pelo componente pai
const labelsMap = inject('labelsMap', {});

const searchContacts = createContactSearcher();

const router = useRouter();
const { t, locale: uiLocale } = useI18n();
const { accountScopedRoute } = useAccount();

const { isStacklab } = useConfig();
const { isWorkspaceV2 } = useWorkspaceV2();

const store = useStore();

const hasCardTemplate = computed(
  () => Boolean(props.item?.kanban_card_template?.presentation)
);
const isSharedRecipient = computed(() => props.item?.access?.shared === true);
const canEditItem = computed(
  () => !isSharedRecipient.value || props.item?.access?.can_edit === true
);

// Instância do MarkdownIt com configurações padrão
const md = new MarkdownIt({
  html: false, // Desabilitar HTML inline para segurança
  breaks: true, // Converter quebras de linha em <br>
  linkify: true, // Converter URLs em links automaticamente
});

const defaultLinkOpenRule =
  md.renderer.rules.link_open ||
  ((tokens, idx, options, env, self) => self.renderToken(tokens, idx, options));

md.renderer.rules.link_open = (tokens, idx, options, env, self) => {
  tokens[idx].attrSet('target', '_blank');
  tokens[idx].attrSet('rel', 'noopener noreferrer');
  return defaultLinkOpenRule(tokens, idx, options, env, self);
};

// Função para renderizar markdown
const renderMarkdown = text => {
  if (!text) return '';
  return md.render(text);
};

// Computed para obter o usuário atual
const currentUser = computed(() => store.getters.getCurrentUser);

// Watch para mudanças no item (para garantir reatividade)
watch(
  () => props.item,
  (newItem, oldItem) => {
    if (newItem && oldItem && newItem.id === oldItem.id) {
      // Item foi atualizado, forçar reatividade se necessário
      if (
        JSON.stringify(newItem.item_details) !==
        JSON.stringify(oldItem.item_details)
      ) {
        // O Vue deve detectar as mudanças automaticamente devido aos computed properties
      }
    }
  },
  { deep: true }
);

// Computed para verificar se o item é visível para o usuário atual
const isItemVisible = computed(() => {
  // Se não há usuário atual, não mostrar o item
  if (!currentUser.value) return false;

  if (isSharedRecipient.value) return props.item?.access?.can_view === true;

  // Se o usuário é administrador, sempre mostrar
  if (currentUser.value.role === 'administrator') return true;

  // Supervisor do funil enxerga todos os cards do funil.
  if (props.isSupervisor) return true;

  // Se não há agentes atribuídos, apenas administradores podem ver
  if (!props.item.assigned_agents || props.item.assigned_agents.length === 0)
    return false;

  // Verificar se o usuário atual está na lista de agentes atribuídos
  return props.item.assigned_agents.some(
    agent => agent.id === currentUser.value.id
  );
});

// Ref para armazenar os dados da conversa - agora busca pelo display_id
const conversationData = computed(() => {
  // Se existir conversation_display_id e kanbanItems, buscar a conversa correspondente
  if (props.item.conversation_display_id && Array.isArray(props.kanbanItems)) {
    // Procura o item que tenha conversation.display_id igual ao informado
    const found = props.kanbanItems.find(
      kItem =>
        kItem.conversation &&
        String(kItem.conversation.display_id) ===
          String(props.item.conversation_display_id)
    );
    if (found && found.conversation) {
      return found.conversation;
    }
  }
  // Fallback: usa a conversa do próprio item
  return props.item.conversation || null;
});

const priorityInfo = computed(() => {
  // Buscar prioridade do item_details
  const priority = props.item.item_details?.priority?.toLowerCase() || 'none';

  // Se for none, retorna null para não exibir o badge
  if (priority === 'none') return null;

  const priorityMap = {
    high: {
      label: t('KANBAN.PRIORITY_LABELS.HIGH'),
      class: 'bg-ruby-50 dark:bg-ruby-800 text-ruby-800 dark:text-ruby-50',
    },
    medium: {
      label: t('KANBAN.PRIORITY_LABELS.MEDIUM'),
      class:
        'bg-yellow-50 dark:bg-yellow-800 text-yellow-800 dark:text-yellow-50',
    },
    low: {
      label: t('KANBAN.PRIORITY_LABELS.LOW'),
      class: 'bg-green-50 dark:bg-green-800 text-green-800 dark:text-green-50',
    },
    urgent: {
      label: t('KANBAN.PRIORITY_LABELS.URGENT'),
      class: 'bg-red-50 dark:bg-red-800 text-red-800 dark:text-red-50',
    },
  };

  return priorityMap[priority] || null;
});

const formattedDate = computed(() => {
  const dateStr = props.item.created_at || props.item.createdAt;
  if (!dateStr) return '';

  try {
    const date = new Date(dateStr);
    return t('KANBAN.CREATED_AT_FORMAT', {
      date: new Intl.DateTimeFormat('pt-BR', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
      }).format(date),
    });
  } catch (error) {
    return '';
  }
});

const formattedValue = computed(() => {
  const value = props.item.item_details?.value;
  const currency = props.item.item_details?.currency;

  // Valor zerado ou vazio não aparece no card: "R$ 0,00" em toda linha é
  // ruído, não informação.
  const numericValue = Number(value);
  if (!Number.isFinite(numericValue) || numericValue === 0) return null;

  try {
    return new Intl.NumberFormat(toIntlLocale(currency?.locale || 'pt-BR'), {
      style: 'currency',
      currency: currency?.code || 'BRL',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(numericValue);
  } catch (error) {
    return String(value);
  }
});

const formattedDeadline = computed(() => {
  const deadline = props.item.item_details?.deadline_at;
  const scheduled = props.item.item_details?.scheduled_at;
  const schedulingType = props.item.item_details?.scheduling_type;

  if (!deadline && !scheduled) return null;

  try {
    const dateStr = scheduled || deadline;

    // Ajuste para corrigir o problema da data
    // Adicione a hora como T12:00:00 para evitar problemas de fuso horário
    let adjustedDateStr = dateStr;
    if (dateStr && dateStr.length === 10) {
      adjustedDateStr = `${dateStr}T12:00:00`;
    }

    const date = new Date(adjustedDateStr);

    if (!Number.isFinite(date.getTime())) {
      return null;
    }

    // Formatação personalizada sem ano
    const day = date.getDate().toString().padStart(2, '0');
    const month = (date.getMonth() + 1).toString().padStart(2, '0');

    let formattedDate = `${day}/${month}`;

    // Adiciona horário se for agendamento
    if (schedulingType === 'schedule' && scheduled) {
      const hours = date.getHours().toString().padStart(2, '0');
      const minutes = date.getMinutes().toString().padStart(2, '0');
      formattedDate += ` ${hours}:${minutes}`;
    }

    return formattedDate;
  } catch (error) {
    return null;
  }
});

const scheduleIcon = computed(() => {
  const schedulingType = props.item.item_details?.scheduling_type;
  if (!schedulingType) return 'alarm';
  return schedulingType === 'schedule' ? 'calendar' : 'alarm';
});

// Título completo: o card mostra até 2 linhas (line-clamp-2) em vez de
// cortar no meio da palavra.
const itemTitle = computed(() => props.item.item_details?.title || '');

const hasLocationData = computed(() =>
  Boolean(
    props.item?.item_details?.location_cep ||
      props.item?.item_details?.location_address
  )
);

const truncatedSenderName = computed(() => {
  const name = conversationData.value?.contact?.name;
  const email = conversationData.value?.contact?.email;
  const defaultText = t('KANBAN.ITEM_CONVERSATION.NO_CONTACT');
  const text = name || email || defaultText;

  return text.length > 25 ? `${text.substring(0, 25)}...` : text;
});

const truncatedLastMessage = computed(() =>
  // Helper puro: tira a marcação markdown (**, _, `, #, >, links) e colapsa
  // os espaços, para a prévia não mostrar símbolo solto.
  buildMessagePreview(conversationData.value?.last_message?.content, 30)
);

const isCardSelected = computed(() => isItemSelected(props.item));

const handleSelectionToggle = event => {
  event?.stopPropagation?.();
  event?.preventDefault?.();
  toggleCardSelection(props.item);
};

const handleClick = event => {
  // Alt + clique apenas colapsa/expande o item, sem navegar
  if (event?.altKey) {
    event.preventDefault?.();
    event.stopPropagation?.();
    toggleCollapseItem();
    return;
  }

  // Clique normal: navegar para a rota kanban_board com o parâmetro item,
  // igual aos itens recentes da sidebar
  router.push(accountScopedRoute('kanban_board', {}, { item: props.item.id }));
  emit('click', props.item);
};

// Enter no card focado abre a ficha, como o clique. Só no próprio card: os
// botões dentro dele tratam o Enter deles.
const handleCardKeydown = event => {
  if (event.target !== event.currentTarget) return;
  event.preventDefault();
  handleClick(event);
};

// Menu "Mover para etapa": quem move é o KanbanTab, pelo mesmo caminho do
// arrastar (motivo de perda, valor do ganho, desfazer).
const handleMoveToStage = stageId => {
  showOptionsMenu.value = false;
  showContextMenu.value = false;
  emit('moveToStage', { item: props.item, stageId });
};

const openItemDetailWithTab = (e, tab) => {
  e?.stopPropagation?.();
  router.push(
    accountScopedRoute('kanban_board', {}, { item: props.item.id, tab })
  );
  emit('click', props.item);
};

const handleEdit = e => {
  e.stopPropagation();
  if (!canEditItem.value) return;
  showContextMenu.value = false;
  emit('edit', props.item);
};

// Adicionar ref para controlar o modal
const showDeleteModal = ref(false);
const itemToDelete = ref(null);
const itemToDeleteName = computed(() => {
  const title = itemToDelete.value?.item_details?.title?.trim();
  if (title) return title;
  return itemToDelete.value?.id ? `Item #${itemToDelete.value.id}` : '';
});

// Modificar o método de delete para mostrar o modal primeiro
const handleDelete = e => {
  e.stopPropagation();
  if (isSharedRecipient.value) return;
  showContextMenu.value = false;
  itemToDelete.value = props.item;
  showDeleteModal.value = true;
};

const handleDuplicate = e => {
  e.stopPropagation();
  if (isSharedRecipient.value) return;
  showOptionsMenu.value = false;
  showContextMenu.value = false;
  emit('duplicate', props.item);
};

// Adicionar método para confirmar a exclusão
const confirmDelete = () => {
  emit('delete', itemToDelete.value);
  showDeleteModal.value = false;
  itemToDelete.value = null;
};

// Função para navegar para a conversa
const navigateToConversation = (e, conversationDisplayId) => {
  e.stopPropagation(); // Previne a propagação do clique para o card

  if (!conversationDisplayId || !conversationData.value) return;

  const route = router.resolve({
    name: 'inbox_conversation',
    params: {
      accountId: props.item.account_id,
      inboxId: conversationData.value.inbox_id,
      conversation_id: conversationDisplayId,
    },
  });
  window.open(route.href, '_blank');
};

// Adicione essas novas refs e funções
const showContextMenu = ref(false);
const contextMenuPosition = ref({ x: 0, y: 0 });

const handleContextMenu = e => {
  e.preventDefault();
  showOptionsMenu.value = false;
  showContextMenu.value = true;
  contextMenuPosition.value = {
    x: e.clientX,
    y: e.clientY,
  };
};

const showSendMessageModal = ref(false);
const showScheduleMessageModal = ref(false);

const handleQuickMessage = () => {
  try {
    nextTick(() => {
      showContextMenu.value = false;
      showSendMessageModal.value = true;
    });
  } catch (error) {
    // Handle error silently
  }
};

const handleScheduleMessage = () => {
  if (
    !(conversationData.value?.display_id != null || conversationData.value?.id)
  ) {
    return;
  }
  showContextMenu.value = false;
  nextTick(() => {
    showScheduleMessageModal.value = true;
  });
};

const handleViewContact = () => {
  // Fecha o menu de contexto
  showContextMenu.value = false;

  // Verifica se temos os dados necessários
  if (!conversationData.value?.contact?.id) {
    return;
  }

  try {
    // Navega para a página do contato
    router.push({
      name: 'contact_profile',
      params: {
        accountId: conversationData.value.account_id,
        contactId: conversationData.value.contact.id,
      },
      query: {
        page: 1,
      },
    });
  } catch (err) {
    // Fallback: navegação direta pela URL
    window.location.href = `/app/accounts/${conversationData.value.account_id}/contacts/${conversationData.value.contact.id}?page=1`;
  }
};

// Estado e ações para modal de vincular/criar conversa
const showLinkConversationModal = ref(false);
const isNewConversationMode = ref(false);
const conversations = ref([]);
const loadingConversations = ref(false);
const conversationSearch = ref('');
const selectedConversationId = ref(null);

// Estado para criação de nova conversa
const newConversationContactSearch = ref('');
const newConversationContacts = ref([]);
const newConversationLoadingContacts = ref(false);
const newConversationSelectedContact = ref(null);
const newConversationInboxes = ref([]);
const newConversationLoadingInboxes = ref(false);
const newConversationSelectedInbox = ref(null);
const newConversationMessage = ref('');
const newConversationCreating = ref(false);

// Modelos de mensagem para nova conversa
const messageTemplates = ref([]);
const loadingMessageTemplates = ref(false);
const selectedMessageTemplateId = ref(null);

const resetNewConversationState = () => {
  isNewConversationMode.value = false;
  newConversationContactSearch.value = '';
  newConversationContacts.value = [];
  newConversationSelectedContact.value = null;
  newConversationInboxes.value = [];
  newConversationSelectedInbox.value = null;
  newConversationMessage.value = '';
  newConversationLoadingContacts.value = false;
  newConversationLoadingInboxes.value = false;
  newConversationCreating.value = false;
  messageTemplates.value = [];
  loadingMessageTemplates.value = false;
  selectedMessageTemplateId.value = null;
};

const loadInitialNewConversationContacts = async () => {
  newConversationLoadingContacts.value = true;
  try {
    const { data } = await ContactAPI.get(1);
    newConversationContacts.value = data.payload || [];
  } catch (error) {
    emitter.emit('newToastMessage', {
      message: 'Erro ao carregar contatos',
      type: 'error',
    });
  } finally {
    newConversationLoadingContacts.value = false;
  }
};

const loadMessageTemplatesForCurrentStage = async () => {
  const funnelId = props.item.funnel_id || props.item.funnel?.id;
  const stageId = props.item.funnel_stage;

  if (!funnelId || !stageId) return;

  loadingMessageTemplates.value = true;
  messageTemplates.value = [];
  selectedMessageTemplateId.value = null;

  try {
    const response = await FunnelAPI.getById(funnelId);
    const funnel = response.data;
    const stages = funnel.stages || {};
    const stage = stages[stageId];
    const templates = stage?.message_templates || [];

    messageTemplates.value = templates;
  } catch (error) {
    emitter.emit('newToastMessage', {
      message: 'Erro ao carregar modelos de mensagem',
      type: 'error',
    });
  } finally {
    loadingMessageTemplates.value = false;
  }
};

// Busca no servidor (nome, telefone, número): o modal abre só com as mais
// recentes, então a conversa antiga chega por aqui. Mesmo padrão do detalhe
// do card (KanbanItemDetailView).
const conversationSearchResults = ref([]);
const conversationSearchResultsQuery = ref('');
let conversationSearchTimer = null;
let conversationSearchRequestId = 0;
watch(conversationSearch, value => {
  clearTimeout(conversationSearchTimer);
  conversationSearchTimer = setTimeout(async () => {
    const query = String(value || '').trim();
    conversationSearchRequestId += 1;
    const requestId = conversationSearchRequestId;
    if (!query) {
      conversationSearchResults.value = [];
      conversationSearchResultsQuery.value = '';
      return;
    }
    try {
      const results = await searchConversations({ q: query });
      if (requestId !== conversationSearchRequestId) return;
      conversationSearchResults.value = results;
    } catch (e) {
      if (requestId !== conversationSearchRequestId) return;
      conversationSearchResults.value = [];
    }
    conversationSearchResultsQuery.value = query;
  }, 300);
});
onUnmounted(() => clearTimeout(conversationSearchTimer));

const filteredConversations = computed(() => {
  if (!conversationSearch.value) return conversations.value;
  const localMatches = conversations.value.filter(c => {
    const sender = c.meta?.sender;
    const text =
      `${c.id} ${sender?.name || ''} ${sender?.email || ''}`.toLowerCase();
    return text.includes(conversationSearch.value.toLowerCase());
  });
  const serverMatches =
    conversationSearchResultsQuery.value === conversationSearch.value.trim()
      ? conversationSearchResults.value
      : [];
  return mergeUniqueConversations(localMatches, serverMatches);
});

const openLinkConversationModal = async () => {
  try {
    showContextMenu.value = false;
    resetNewConversationState();
    conversations.value = [];
    loadingConversations.value = true;
    conversationSearch.value = '';
    selectedConversationId.value =
      props.item.item_details?.conversation_id || null;
    showLinkConversationModal.value = true;

    // Antes percorria TODAS as páginas de conversas antes de abrir (35
    // requisições no staging, milhares numa conta grande de produção).
    conversations.value = await fetchRecentConversations();
    // Se já existir uma conversa vinculada, garantir que ela fique selecionada
    if (props.item.item_details?.conversation_id) {
      selectedConversationId.value = props.item.item_details.conversation_id;
    }
  } catch (error) {
    emitter.emit('newToastMessage', {
      message: t('KANBAN.ERROR_LOAD_CONVERSATIONS'),
      type: 'error',
    });
  } finally {
    loadingConversations.value = false;
  }
};

const handleLinkConversation = () => {
  openLinkConversationModal();
};
const handleCreateNewConversation = () => {
  // Alterna para modo de nova conversa dentro do próprio modal
  isNewConversationMode.value = true;
  if (
    !newConversationContacts.value.length &&
    !newConversationLoadingContacts.value
  ) {
    loadInitialNewConversationContacts();
  }
  if (!messageTemplates.value.length && !loadingMessageTemplates.value) {
    loadMessageTemplatesForCurrentStage();
  }
};

const searchNewConversationContacts = async () => {
  if (!newConversationContactSearch.value) return;
  newConversationLoadingContacts.value = true;
  newConversationContacts.value = [];
  try {
    // Reutiliza o helper existente de busca de contatos
    newConversationContacts.value = await searchContacts(
      newConversationContactSearch.value
    );
  } catch (error) {
    emitter.emit('newToastMessage', {
      message: 'Erro ao buscar contatos',
      type: 'error',
    });
  } finally {
    newConversationLoadingContacts.value = false;
  }
};

const selectNewConversationContact = async contact => {
  newConversationSelectedContact.value = contact;
  newConversationInboxes.value = [];
  newConversationSelectedInbox.value = null;
  newConversationLoadingInboxes.value = true;
  try {
    const inboxes = await fetchContactableInboxes(contact.id);
    newConversationInboxes.value = inboxes;
    if (inboxes.length > 0) {
      newConversationSelectedInbox.value = inboxes[0];
    }
  } catch (error) {
    emitter.emit('newToastMessage', {
      message: 'Erro ao carregar canais do contato',
      type: 'error',
    });
  } finally {
    newConversationLoadingInboxes.value = false;
  }
};

const createNewConversationFromKanban = async () => {
  if (
    !newConversationSelectedContact.value ||
    !newConversationSelectedInbox.value ||
    newConversationCreating.value
  )
    return;

  newConversationCreating.value = true;
  try {
    const baseMessage =
      newConversationMessage.value ||
      `Nova conversa iniciada a partir do kanban: ${
        props.item.item_details?.title || `Item #${props.item.id}`
      }`;

    const payload = prepareNewMessagePayload({
      targetInbox: newConversationSelectedInbox.value,
      selectedContact: newConversationSelectedContact.value,
      message: baseMessage,
      subject: null,
      ccEmails: null,
      bccEmails: null,
      currentUser: currentUser.value,
      attachedFiles: [],
      directUploadsEnabled: false,
    });

    const isFromWhatsApp =
      newConversationSelectedInbox.value.channelType === 'Channel::Whatsapp';

    const data = await store.dispatch('contactConversations/create', {
      params: payload,
      isFromWhatsApp,
    });

    selectedConversationId.value = data.display_id || data.id;
    await confirmLinkConversation();

    resetNewConversationState();
    showLinkConversationModal.value = false;

    emitter.emit('newToastMessage', {
      message: 'Conversa criada e vinculada com sucesso',
      type: 'success',
    });
  } catch (error) {
    emitter.emit('newToastMessage', {
      message: 'Erro ao criar e vincular conversa',
      type: 'error',
    });
  } finally {
    newConversationCreating.value = false;
  }
};

const confirmLinkConversation = async () => {
  if (!selectedConversationId.value) return;
  try {
    const updatedItem = {
      ...props.item,
      item_details: {
        ...props.item.item_details,
        conversation_id: selectedConversationId.value,
      },
      conversation_display_id: selectedConversationId.value,
    };

    const { data } = await KanbanAPI.update(props.item.id, updatedItem);
    if (data) {
      Object.assign(props.item, data);
    }

    showLinkConversationModal.value = false;
    emitter.emit('newToastMessage', {
      message: t('KANBAN.FORM.NOTES.LINK_CONVERSATION_SUCCESS'),
      type: 'success',
    });
    emit('conversationUpdated');
  } catch (error) {
    emitter.emit('newToastMessage', {
      message: t('KANBAN.ERROR_LINK_CONVERSATION'),
      type: 'error',
    });
  }
};

const handleDragStart = e => {
  if (!canEditItem.value) {
    e.preventDefault();
    return;
  }
  emit('dragstart', e);
};

// Add new handler for dragend
const handleDragEnd = e => {
  emit('itemDragend', e);
};

// Adicionar watch para monitorar mudanças
watch(showSendMessageModal, newValue => {
  if (!newValue) {
    nextTick(() => {
      showContextMenu.value = false;
    });
  }
});

// Adicione essa nova ref
const showFullDescription = ref(false);

const isDescriptionTruncated = computed(() => {
  const description = props.item.item_details?.description;
  if (!description) return false;

  return renderMarkdown(description).length > 150;
});

// Corrigido: só retorna a descrição se existir
const truncatedDescription = computed(() => {
  const description = props.item.item_details?.description;
  if (!description) return '';
  const rendered = renderMarkdown(description);
  if (showFullDescription.value) return rendered;

  // Renderizar markdown primeiro, depois truncar o HTML
  if (rendered.length <= 150) return rendered;

  // Truncar o HTML mantendo as tags válidas
  const truncated = rendered.substring(0, 150);
  const lastTagStart = truncated.lastIndexOf('<');
  const lastTagEnd = truncated.lastIndexOf('>');

  // Se há uma tag aberta no final, fechar ela
  if (lastTagStart > lastTagEnd) {
    return truncated.substring(0, lastTagStart) + '...';
  }

  return truncated + '...';
});

// Adicione essa nova função
const toggleDescription = e => {
  e.stopPropagation();
  showFullDescription.value = !showFullDescription.value;
};

const handleFilter = filters => {
  const filteredItems = props.kanbanItems.filter(item => {
    // Lógica de filtro aqui
  });
  emit('filter', filteredItems);
};

// Computed agentInfo para trabalhar com múltiplos agentes
const agentInfo = computed(() => {
  // Verificar se há agentes atribuídos
  if (props.item.assigned_agents && props.item.assigned_agents.length > 0) {
    return props.item.assigned_agents.map(agent => ({
      id: agent.id,
      name: agent.name,
      avatar_url: agent.avatar_url || '',
      assigned_at: agent.assigned_at,
      assigned_by: agent.assigned_by,
    }));
  }

  return [];
});

// Computed para o agente principal (primeiro da lista)
const primaryAgent = computed(() => {
  return agentInfo.value.length > 0 ? agentInfo.value[0] : null;
});

// Computed para mostrar se há múltiplos agentes
const hasMultipleAgents = computed(() => {
  return agentInfo.value.length > 1;
});

// Computed para mostrar o número de agentes adicionais
const additionalAgentsCount = computed(() => {
  return Math.max(0, agentInfo.value.length - 1);
});

// Adicionar nova ref para controlar o menu de opções
const showOptionsMenu = ref(false);

// Compartilhar: os menus do cartão chamam a instância headless na raiz.
const shareControlRef = ref(null);
const { checkPermissions: checkSharePermissions } = usePolicy();
const canSendCardOnInternalChat = computed(() =>
  checkSharePermissions(INTERNAL_CHAT_PERMISSIONS)
);
const closeCardMenus = () => {
  showOptionsMenu.value = false;
  showContextMenu.value = false;
};
const shareCopyLink = () => {
  closeCardMenus();
  shareControlRef.value?.copyLink();
};
const shareOpenSend = () => {
  closeCardMenus();
  shareControlRef.value?.openSend();
};
const shareOpenManage = () => {
  closeCardMenus();
  shareControlRef.value?.openManage();
};

// Fechar menu ao clicar fora
onMounted(() => {
  document.addEventListener('click', () => {
    showOptionsMenu.value = false;
    // O popover de exibição do card fecha junto: ele nasce no body, então não
    // é filho do card e não recebe o clique de fora por bolha.
  });

  // Faixa do próximo passo: um minuto é o menor passo que o texto mostra.
  // Só o card que tem próximo passo precisa do relógio: um board grande não
  // deve criar centenas de timers à toa.
  if (props.item?.next_step) {
    nowTickTimer = setInterval(() => {
      nowTick.value = new Date();
    }, 60000);
  }

  // Carregar configurações de visibilidade
  const allSettings = JSON.parse(
    contaLocalStorage.getItem('kanban_items_visibility') || '{}'
  );
  const itemSettings = allSettings[props.item.id];

  if (itemSettings) {
    try {
      showDescriptionField.value = itemSettings.showDescriptionField ?? true;
      showLabelsField.value = itemSettings.showLabelsField ?? true;
      showPriorityField.value = itemSettings.showPriorityField ?? true;
      showValueField.value = itemSettings.showValueField ?? true;
      showDeadlineField.value = itemSettings.showDeadlineField ?? true;
      showConversationField.value = itemSettings.showConversationField ?? true;
      showChecklistField.value = itemSettings.showChecklistField ?? true;
      showAgentField.value = itemSettings.showAgentField ?? true;
      showMetadataField.value = itemSettings.showMetadataField ?? true;
    } catch (error) {
      // Handle error silently
    }
  }

  // Carregar estado de colapso
  loadCollapsedState();

  // Adicionar listener para evento global
  emitter.on('kanbanItemsCollapsedStateChanged', loadCollapsedState);

  if (!agentList.value.length) {
    store.dispatch('agents/get');
  }
});

onUnmounted(() => {
  document.removeEventListener('click', () => {
    showOptionsMenu.value = false;
  });

  if (nowTickTimer) {
    clearInterval(nowTickTimer);
    nowTickTimer = null;
  }

  // Remover o listener ao desmontar o componente
  emitter.off('kanbanItemsCollapsedStateChanged', loadCollapsedState);
});

// Função para carregar o estado de colapso do localStorage
const loadCollapsedState = () => {
  const collapsedItems = JSON.parse(
    contaLocalStorage.getItem('kanban_collapsed_items') || '{}'
  );

  if (props.item.id in collapsedItems) {
    isItemCollapsed.value = collapsedItems[props.item.id];
  }
};

const showStatusModal = ref(false);
const statusForm = ref({
  status: '',
  reason: '',
  selectedOffer: null,
  selectedWinReason: null,
  selectedLossReason: null,
});

// Computed para buscar funnels ativos
const funnels = computed(() =>
  store.getters['funnel/getFunnels'].filter(funnel => funnel.active)
);

// Computed para buscar o funil atual do item
const currentFunnel = computed(() => {
  // Tentar diferentes formas de buscar o funnel_id
  const funnelId = props.item.funnel_id || props.item.funnel?.id;

  if (!funnelId) return null;

  // Usar == para comparar número com string
  return funnels.value.find(f => f.id == funnelId);
});

// Computed para motivos de ganho
const winReasons = computed(() => {
  return currentFunnel.value?.settings?.win_reasons || [];
});

// Computed para motivos de perda
const lossReasons = computed(() => {
  return currentFunnel.value?.settings?.loss_reasons || [];
});

const handleStatusClick = async () => {
  if (isSharedRecipient.value) return;
  // Buscar funnels antes de abrir o modal
  try {
    await store.dispatch('funnel/fetch');
  } catch (error) {
    console.error('Erro ao buscar funnels:', error);
  }

  // Inicializa o form com o status atual
  const currentStatus =
    props.item.item_details?.status || conversationData.value?.status || 'open';
  const itemOffers = props.item.item_details?.offers || [];
  const closedOffer = props.item.item_details?.closed_offer || null;
  // Resolver selectedOffer para a mesma referência da lista do item (para o === no template)
  const resolvedOffer =
    closedOffer && itemOffers.length
      ? itemOffers.find(
          o =>
            String(o.value) === String(closedOffer.value) &&
            (o.description || '').trim() ===
              (closedOffer.description || '').trim() &&
            (o.currency?.code || o.currency) ===
              (closedOffer.currency?.code || closedOffer.currency)
        ) || closedOffer
      : closedOffer;

  statusForm.value = {
    status: currentStatus,
    reason: props.item.item_details?.reason || '',
    selectedOffer: resolvedOffer,
    selectedWinReason: props.item.item_details?.win_reason || null,
    selectedLossReason: props.item.item_details?.loss_reason || null,
  };

  showStatusModal.value = true;
};

const handleStatusSave = async () => {
  try {
    // Preparar o campo reason baseado no status
    let reasonText = null;

    if (statusForm.value.status === 'won') {
      // Se selecionou "Outro", usar o texto do textarea
      if (statusForm.value.selectedWinReason === 'other') {
        reasonText = statusForm.value.reason || null;
      } else {
        // Usar o título do win_reason selecionado
        const selectedReason = winReasons.value.find(
          r => r.id === statusForm.value.selectedWinReason
        );
        reasonText = selectedReason?.title || null;
      }
    } else if (statusForm.value.status === 'lost') {
      // Se selecionou "Outro", usar o texto do textarea
      if (statusForm.value.selectedLossReason === 'other') {
        reasonText = statusForm.value.reason || null;
      } else {
        // Usar o título do loss_reason selecionado
        const selectedReason = lossReasons.value.find(
          r => r.id === statusForm.value.selectedLossReason
        );
        reasonText = selectedReason?.title || null;
      }
    }

    // Sempre fazer update completo do item_details para garantir que o status seja atualizado
    const updatedItem = {
      ...props.item,
      item_details: {
        ...props.item.item_details,
        status: statusForm.value.status,
        reason: reasonText,
        closed_offer:
          statusForm.value.status === 'won'
            ? statusForm.value.selectedOffer
            : null,
        win_reason:
          statusForm.value.status === 'won' &&
          statusForm.value.selectedWinReason !== 'other'
            ? statusForm.value.selectedWinReason
            : null,
        loss_reason:
          statusForm.value.status === 'lost' &&
          statusForm.value.selectedLossReason !== 'other'
            ? statusForm.value.selectedLossReason
            : null,
      },
    };

    const { data } = await KanbanAPI.update(props.item.id, updatedItem);
    if (data) {
      Object.assign(props.item, data);
    }

    showStatusModal.value = false;
    emit('conversationUpdated');

    // Mostrar toast de sucesso
    emitter.emit('newToastMessage', {
      message: 'Status atualizado com sucesso',
      type: 'success',
    });
  } catch (error) {
    emitter.emit('newToastMessage', {
      message: 'Erro ao atualizar status',
      type: 'error',
    });
  }
};

// Adicione este computed
const getStatusLabel = computed(() => {
  const status = props.item.item_details?.status;

  if (!status) return t('KANBAN.BULK_ACTIONS.ITEM_STATUS.OPEN');

  if (status === 'won') {
    const date = new Date(
      props.item.item_details?.updated_at
    ).toLocaleDateString();
    return t('KANBAN.BULK_ACTIONS.ITEM_STATUS.WON');
  }

  if (status === 'lost') {
    const date = new Date(
      props.item.item_details?.updated_at
    ).toLocaleDateString();
    return t('KANBAN.BULK_ACTIONS.ITEM_STATUS.LOST');
  }

  return 'Status';
});

// Cor do ponto de status no rodapé do card padrão. Só token n-*, nunca hex:
// a mesma classe precisa funcionar no tema claro e no escuro.
const statusDotClass = computed(() => {
  switch (props.item.item_details?.status || 'open') {
    case 'won':
      return 'bg-n-teal-9';
    case 'lost':
      return 'bg-n-ruby-9';
    case 'pending':
      return 'bg-n-amber-9';
    case 'resolved':
      return 'bg-n-blue-9';
    case 'snoozed':
      return 'bg-n-slate-9';
    default:
      return 'bg-n-slate-10';
  }
});

// Adicione este computed para exibir o status real do item (badge do card)
const displayedStatus = computed(() => {
  // Sempre pega do item_details.status, se não tiver marca como 'open'
  const itemStatus = props.item.item_details?.status || 'open';

  if (itemStatus === 'open') {
    return t('KANBAN.BULK_ACTIONS.ITEM_STATUS.OPEN');
  }
  if (itemStatus === 'won') {
    return t('KANBAN.BULK_ACTIONS.ITEM_STATUS.WON');
  }
  if (itemStatus === 'lost') {
    return t('KANBAN.BULK_ACTIONS.ITEM_STATUS.LOST');
  }
  if (itemStatus === 'pending') {
    return t('KANBAN.ITEM_STATUS.PENDING');
  }
  if (itemStatus === 'resolved') {
    return t('KANBAN.ITEM_STATUS.RESOLVED');
  }
  if (itemStatus === 'snoozed') {
    return t('KANBAN.ITEM_STATUS.SNOOZED');
  }
  return itemStatus;
});

// Atualizado para usar o novo formato do backend (total_count)
const attachmentsCount = computed(() => {
  // Verifica se attachments é um array (formato show) ou objeto com total_count (formato index)
  if (Array.isArray(props.item.attachments)) {
    // Formato antigo/completo: soma todos os anexos
    const itemAttachments = props.item.attachments?.length || 0;
    const itemDetailsAttachments =
      props.item.item_details?.attachments?.length || 0;
    const noteAttachments = Array.isArray(props.item.item_details?.notes)
      ? props.item.item_details.notes.reduce((count, note) => {
          return count + (note.attachments?.length || 0);
        }, 0)
      : 0;

    return itemAttachments + itemDetailsAttachments + noteAttachments;
  }
  // Novo formato do index: usa total_count diretamente
  return props.item.attachments?.total_count || 0;
});

// Atualizado para usar o novo formato do backend (total_count)
const notesCount = computed(() => {
  const notes = props.item.item_details?.notes;

  // Verifica se notes é um array (formato show) ou objeto com total_count (formato index)
  if (Array.isArray(notes)) {
    // Formato antigo/completo: conta os itens do array
    return notes?.length || 0;
  }
  // Novo formato do index: usa total_count diretamente
  return notes?.total_count || 0;
});

// Adiciona computed properties para o progresso do checklist
// Atualizado para usar o novo formato do backend (total_count e completed_count)
const totalItems = computed(() => {
  // Verifica se checklist é um array (formato show) ou objeto com contagens (formato index)
  if (Array.isArray(props.item.checklist)) {
    // Formato antigo/completo: conta os itens do array
    return props.item.checklist?.length || 0;
  }
  // Novo formato do index: usa total_count diretamente
  return props.item.checklist?.total_count || 0;
});

const completedItems = computed(() => {
  // Verifica se checklist é um array (formato show) ou objeto com contagens (formato index)
  if (Array.isArray(props.item.checklist)) {
    // Formato antigo/completo: conta os itens completados
    return props.item.checklist?.filter(item => item.completed)?.length || 0;
  }
  // Novo formato do index: usa completed_count diretamente
  return props.item.checklist?.completed_count || 0;
});

const checklistProgress = computed(() => {
  if (totalItems.value === 0) return 0;
  return (completedItems.value / totalItems.value) * 100;
});

// Próxima ação sugerida com base no checklist
// Só funciona quando o checklist vem como array completo
const nextChecklistItem = computed(() => {
  if (!Array.isArray(props.item.checklist)) return null;
  return props.item.checklist.find(item => !item.completed) || null;
});

// Adicione uma computed property para o tempo na etapa
const timeInStage = computed(() => {
  if (!props.item.stage_entered_at) return '';
  try {
    const now = new Date();
    const entered = new Date(props.item.stage_entered_at);
    const diffMs = now.getTime() - entered.getTime();
    const diffMins = Math.floor(diffMs / 60000);
    const diffHours = Math.floor(diffMins / 60);
    const diffDays = Math.floor(diffHours / 24);
    const diffYears = Math.floor(diffDays / 365);
    if (diffYears > 0) return `${diffYears}a`;
    if (diffDays > 0) return `${diffDays}d`;
    if (diffHours > 0) return `${diffHours}h`;
    if (diffMins > 0) return `${diffMins}m`;
    return '<1m';
  } catch (error) {
    return '';
  }
});

// SLA da etapa (em horas), configurado no funil
const stageSlaHours = computed(() => {
  const stageId = props.item.funnel_stage;
  if (!currentFunnel.value || !stageId) return null;

  const stageConfig = currentFunnel.value.stages?.[stageId];
  if (
    !stageConfig ||
    stageConfig.sla === undefined ||
    stageConfig.sla === null
  ) {
    return null;
  }

  const numericSla = Number(stageConfig.sla);
  if (!Number.isFinite(numericSla) || numericSla <= 0) {
    return null;
  }

  return numericSla; // horas
});

// Indica se o item já estourou o SLA da etapa
const isStageSlaBreached = computed(() => {
  if (!stageSlaHours.value || !props.item.stage_entered_at) return false;

  try {
    const entered = new Date(props.item.stage_entered_at);
    if (!Number.isFinite(entered.getTime())) return false;

    const now = new Date();
    const diffHours = (now.getTime() - entered.getTime()) / (1000 * 60 * 60);

    return diffHours >= stageSlaHours.value;
  } catch (e) {
    return false;
  }
});

// Adicione este computed
const conversationLabels = computed(() => {
  return conversationData.value?.label_list || [];
});

// Adicione esta função helper para escurecer cores
const darkenColor = (color, amount = 0.2) => {
  try {
    if (!color) return '#64748B';

    // Remove o # se existir
    const hex = color.replace('#', '');

    // Converte para RGB
    const r = parseInt(hex.substring(0, 2), 16);
    const g = parseInt(hex.substring(2, 4), 16);
    const b = parseInt(hex.substring(4, 6), 16);

    // Escurece cada componente
    const darkerR = Math.floor(r * (1 - amount));
    const darkerG = Math.floor(g * (1 - amount));
    const darkerB = Math.floor(b * (1 - amount));

    // Converte de volta para hex
    return `#${darkerR.toString(16).padStart(2, '0')}${darkerG
      .toString(16)
      .padStart(2, '0')}${darkerB.toString(16).padStart(2, '0')}`;
  } catch {
    return '#64748B';
  }
};

// Adicione este computed
const contactAvatar = computed(() => {
  return conversationData.value?.contact?.thumbnail || '';
});

// Computed para obter as offers disponíveis do item
const availableOffers = computed(() => {
  const offers = props.item.item_details?.offers || [];
  return Array.isArray(offers) ? offers : [];
});

// Phase 2.9.8 I+G: resumo VOIP do card (backend envia voip_summary quando
// voip_calls ligado). Badge de lead_profile + info da ultima chamada.
const voipSummary = computed(() => props.item.voip_summary || null);

const voipProfileBadge = computed(() => {
  const profile = voipSummary.value?.lead_profile;
  if (!profile) return null;
  const map = {
    hot: {
      icon: '🔥',
      label: 'Hot',
      color:
        'bg-red-100 text-red-700 dark:bg-red-900/40 dark:text-red-300 border-red-200 dark:border-red-800',
    },
    warm: {
      icon: '🌤',
      label: 'Warm',
      color:
        'bg-amber-100 text-amber-700 dark:bg-amber-900/40 dark:text-amber-300 border-amber-200 dark:border-amber-800',
    },
    cold: {
      icon: '❄',
      label: 'Cold',
      color:
        'bg-sky-100 text-sky-700 dark:bg-sky-900/40 dark:text-sky-300 border-sky-200 dark:border-sky-800',
    },
  };
  return map[profile] || null;
});

const voipLastCallLabel = computed(() => {
  const lc = voipSummary.value?.last_call;
  if (!lc?.created_at) return null;
  const days = Math.floor(
    (Date.now() - new Date(lc.created_at).getTime()) / 86400000
  );
  const when = days === 0 ? 'hoje' : days === 1 ? 'ontem' : `há ${days}d`;
  const duration =
    lc.duration_seconds > 0
      ? `${Math.floor(lc.duration_seconds / 60)}m${lc.duration_seconds % 60}s`
      : '';
  const dir =
    lc.direction === 'inbound' ? '↓' : lc.direction === 'outbound' ? '↑' : '';
  const disp = lc.disposition ? ` · ${lc.disposition}` : '';
  return `${dir} ${when}${duration ? ` (${duration})` : ''}${disp}`.trim();
});

// Selo de status com as escalas do tema (n-*): o fundo 3, a borda 6 e o texto
// 11 da mesma cor têm contraste nos dois temas. Antes eram hex fixos de tema
// claro, e no escuro o selo virava um retângulo claro no meio do card.
const toneStyle = tone => ({
  backgroundColor: `rgb(var(--${tone}-3))`,
  color: `rgb(var(--${tone}-11))`,
  border: `1px solid rgb(var(--${tone}-6))`,
});

const ITEM_STATUS_TONE = {
  won: 'teal',
  lost: 'ruby',
  open: 'slate',
  pending: 'amber',
  resolved: 'blue',
  snoozed: 'slate',
};

// Método para obter o estilo do badge de status do item
const getStatusBadgeStyle = () => {
  // Sempre pega do item_details.status, se não tiver marca como 'open'
  const effectiveStatus = props.item.item_details?.status || 'open';
  return toneStyle(ITEM_STATUS_TONE[effectiveStatus] || 'slate');
};

const CONVERSATION_STATUS_TONE = {
  open: 'blue',
  pending: 'amber',
  resolved: 'teal',
  snoozed: 'slate',
  lost: 'ruby',
  won: 'teal',
};

// Cor do selo de status da conversa vinculada
const conversationStatusTone = computed(
  () => CONVERSATION_STATUS_TONE[conversationData.value?.status] || 'slate'
);
const conversationStatusBadgeStyle = computed(() => {
  const { backgroundColor, color, border } = toneStyle(
    conversationStatusTone.value
  );
  return { background: backgroundColor, color, border };
});

const conversationStatusLabel = computed(() => {
  const status = (conversationData.value?.status || '').toLowerCase();

  const statusMap = {
    open: 'KANBAN.ITEM_CONVERSATION.STATUS.OPEN',
    pending: 'KANBAN.ITEM_CONVERSATION.STATUS.PENDING',
    resolved: 'KANBAN.ITEM_CONVERSATION.STATUS.RESOLVED',
    snoozed: 'KANBAN.ITEM_CONVERSATION.STATUS.SNOOZED',
  };

  const key = statusMap[status];
  return key ? t(key) : conversationData.value?.status;
});

// Conversa aberta é o caso comum e repetia o "Aberto" do card. A pílula só
// aparece quando a conversa está em outro estado (pendente, resolvida, adiada).
const showConversationStatus = computed(() => {
  const status = (conversationData.value?.status || '').toLowerCase();
  return Boolean(status) && status !== 'open';
});

// Adicione estas refs para controlar a visibilidade dos campos
const showDescriptionField = ref(true);
const showLabelsField = ref(true);
const showPriorityField = ref(true);
const showValueField = ref(true);
const showDeadlineField = ref(true);
const showConversationField = ref(true);
const showChecklistField = ref(true);
const showAgentField = ref(true);
const showMetadataField = ref(true);

// ---------------------------------------------------------------------------
// Proximo passo do card (faixa verde, vermelha ou tracejada)
// ---------------------------------------------------------------------------

// `nowTick` existe para a faixa nao mentir num board que fica aberto o dia
// inteiro: o `overdue` do servidor continua mandando, isto so reescreve o
// "hoje, 15:30" quando a virada de minuto muda o texto relativo.
const nowTick = ref(new Date());
let nowTickTimer = null;

const nextStepBadge = computed(() =>
  buildNextStepBadge(
    props.item?.next_step,
    nowTick.value,
    toIntlLocale(uiLocale.value || 'pt_BR')
  )
);

// Card compartilhado nao recebe `next_step` da API e nem pode editar, entao a
// faixa tracejada "Definir proximo passo" nao faz sentido nele.
const showNextStepBand = computed(() => {
  if (!cardDisplay.value.nextStep) return false;
  if (isItemCollapsed.value) return false;
  if (nextStepBadge.value.tone !== 'none') return true;
  return !isSharedRecipient.value && canEditItem.value;
});

const nextStepLabel = computed(() =>
  t(nextStepBadge.value.labelKey, nextStepBadge.value.labelParams)
);

// Tokens do tema, nunca hex: o par 3/11 do radix ja e legivel no claro e no
// escuro. `bg-black/NN` fica fora por decisao do design system.
const nextStepBandClass = computed(() => {
  const tone = nextStepBadge.value.tone;
  if (tone === 'late') return 'bg-n-ruby-3 text-n-ruby-11 border-transparent';
  if (tone === 'ok') return 'bg-n-teal-3 text-n-teal-11 border-transparent';
  return 'bg-transparent text-n-slate-11 border-dashed border-n-weak';
});

const handleNextStepClick = event => {
  openItemDetailWithTab(event, nextStepPanelTab(props.item?.next_step));
};

// ---------------------------------------------------------------------------
// "Exibicao do card": preferencia POR USUARIO, por cima da config do card
// ---------------------------------------------------------------------------

// Só LEITURA da preferência: quem edita é o controle único da barra
// (KanbanCardDisplayPopover).
const { uiSettings } = useUISettings();

const cardDisplayPreference = computed(() =>
  normalizeCardDisplay(uiSettings.value?.[CARD_DISPLAY_UI_SETTINGS_KEY])
);

// O que a configuracao do card (modal "Personalizar campos", por item) deixa
// aparecer. A preferencia do usuario so pode esconder a partir daqui.
const cardDisplayAllowed = computed(() => ({
  description: showDescriptionField.value,
  labels: showLabelsField.value,
  conversationPreview: showConversationField.value,
  value: showValueField.value,
  assignee: showAgentField.value,
  timeInStage: showMetadataField.value,
  // `nextStep` nao tem par no modal antigo: bloco novo, so o usuario decide.
  nextStep: true,
}));

const cardDisplay = computed(() =>
  resolveCardDisplay(cardDisplayAllowed.value, cardDisplayPreference.value)
);

// Adicionar ref para controlar o estado expandido/colapsado
const isItemCollapsed = ref(false);

// Adicione este ref e função para controlar o modal de visibilidade
const showVisibilityModal = ref(false);

const handleVisibilityClick = () => {
  showOptionsMenu.value = false;
  showContextMenu.value = false;
  showVisibilityModal.value = true;
};

// Função para alternar entre expandido/colapsado
const toggleCollapseItem = () => {
  isItemCollapsed.value = !isItemCollapsed.value;
  saveItemCollapsedState();
  showOptionsMenu.value = false;
  showContextMenu.value = false;
};

// Função para salvar o estado de colapso no localStorage
const saveItemCollapsedState = () => {
  const collapsedItems = JSON.parse(
    contaLocalStorage.getItem('kanban_collapsed_items') || '{}'
  );
  collapsedItems[props.item.id] = isItemCollapsed.value;
  contaLocalStorage.setItem(
    'kanban_collapsed_items',
    JSON.stringify(collapsedItems)
  );
};

// Função para salvar configurações no localStorage
const saveFieldVisibility = () => {
  const settings = {
    showDescriptionField: showDescriptionField.value,
    showLabelsField: showLabelsField.value,
    showPriorityField: showPriorityField.value,
    showValueField: showValueField.value,
    showDeadlineField: showDeadlineField.value,
    showConversationField: showConversationField.value,
    showChecklistField: showChecklistField.value,
    showAgentField: showAgentField.value,
    showMetadataField: showMetadataField.value,
  };

  // Carregar configurações existentes
  const allSettings = JSON.parse(
    contaLocalStorage.getItem('kanban_items_visibility') || '{}'
  );

  // Atualizar apenas as configurações deste item específico
  allSettings[props.item.id] = settings;

  // Salvar de volta no localStorage
  contaLocalStorage.setItem(
    'kanban_items_visibility',
    JSON.stringify(allSettings)
  );
};

// Observe as mudanças em todas as configurações de visibilidade
watch(
  [
    showDescriptionField,
    showLabelsField,
    showPriorityField,
    showValueField,
    showDeadlineField,
    showConversationField,
    showChecklistField,
    showAgentField,
    showMetadataField,
  ],
  () => {
    saveFieldVisibility();
  }
);

const isUrgent = computed(
  () => props.item.item_details?.priority?.toLowerCase() === 'urgent'
);

// Atualizar isItemCollapsed para respeitar forceExpanded
watch(
  () => props.forceExpanded,
  newVal => {
    if (newVal) {
      isItemCollapsed.value = false;
    }
  },
  { immediate: true }
);

// Modal de atribuição rápida de agente
const showAgentAssignModal = ref(false);
const agentAssignLoading = ref(false);
const selectedAgentId = ref(null);
const agentList = computed(() => store.getters['agents/getAgents']);

// Hover state para avatar do agente
const showEditAgentIcon = ref(false);

// Função segura para ícone
function safeIcon(icon) {
  if (typeof icon === 'string' && icon.length > 0) return icon;
  return 'user';
}

// Função para abrir modal
const openAgentAssignModal = () => {
  selectedAgentId.value = primaryAgent.value?.id || null;
  showAgentAssignModal.value = true;
};

// Função para atribuir agente (atualizada para múltiplos)
const assignAgent = async () => {
  if (!selectedAgentId.value || agentAssignLoading.value) return;
  agentAssignLoading.value = true;
  try {
    // Usar o novo endpoint para atribuir agente
    const { data } = await KanbanAPI.assignAgent(
      props.item.id,
      selectedAgentId.value
    );
    if (data) {
      Object.assign(props.item, data);
    }
    showAgentAssignModal.value = false;
    emit('conversationUpdated');
    emitter.emit('newToastMessage', {
      message: t('KANBAN.FORM.AGENT.ASSIGNED_SUCCESS'),
      type: 'success',
    });
  } catch (error) {
    emitter.emit('newToastMessage', {
      message: t('KANBAN.FORM.AGENT.ASSIGNED_ERROR'),
      type: 'error',
    });
  } finally {
    agentAssignLoading.value = false;
  }
};

// Função para remover agente
const removeAgent = async agentId => {
  try {
    const { data } = await KanbanAPI.removeAgent(props.item.id, agentId);
    if (data) {
      Object.assign(props.item, data);
    }
    emit('conversationUpdated');
    emitter.emit('newToastMessage', {
      message: 'Agente removido com sucesso',
      type: 'success',
    });
  } catch (error) {
    emitter.emit('newToastMessage', {
      message: 'Erro ao remover agente',
      type: 'error',
    });
  }
};

// Garantir que a lista de agentes está carregada
vueOnMounted(() => {
  if (!agentList.value.length) {
    store.dispatch('agents/get');
  }
});

// Ref para busca de agente
const agentSearch = ref('');
const filteredAgentList = computed(() => {
  if (!agentSearch.value) return agentList.value;
  return agentList.value.filter(agent =>
    (agent.name || '').toLowerCase().includes(agentSearch.value.toLowerCase())
  );
});

const isConversationCardHovered = ref(false);

// Ref para controlar o modal de prioridade
const showPriorityModal = ref(false);
const priorityAssignLoading = ref(false);
const selectedPriority = ref(props.item.item_details?.priority || 'none');

const openPriorityModal = () => {
  selectedPriority.value = props.item.item_details?.priority || 'none';
  showPriorityModal.value = true;
};

const assignPriority = async () => {
  if (priorityAssignLoading.value) return;
  priorityAssignLoading.value = true;
  try {
    const updatedItem = {
      ...props.item,
      item_details: {
        ...props.item.item_details,
        priority: selectedPriority.value,
      },
    };
    const { data } = await KanbanAPI.update(props.item.id, updatedItem);
    if (data) {
      Object.assign(props.item, data);
    }
    showPriorityModal.value = false;
    emit('conversationUpdated');
    emitter.emit('newToastMessage', {
      message: t('KANBAN.FORM.PRIORITY.ASSIGNED_SUCCESS'),
      type: 'success',
    });
  } catch (error) {
    emitter.emit('newToastMessage', {
      message: t('KANBAN.FORM.PRIORITY.ASSIGNED_ERROR'),
      type: 'error',
    });
  } finally {
    priorityAssignLoading.value = false;
  }
};

const isLossReasonRequired = computed(() => {
  return currentFunnel.value?.settings?.require_loss_reason === true;
});

const isReasonMissing = computed(() => {
  if (statusForm.value.status !== 'lost' || !isLossReasonRequired.value)
    return false;

  if (lossReasons.value.length > 0) {
    if (!statusForm.value.selectedLossReason) return true;
    if (
      statusForm.value.selectedLossReason === 'other' &&
      !statusForm.value.reason?.trim()
    )
      return true;
  } else if (!statusForm.value.reason?.trim()) return true;
  return false;
});
</script>

<template>
  <div
    v-if="isItemVisible"
    class="group flex flex-col p-4 bg-n-solid-3 rounded-xl border border-n-weak transition-all duration-200 cursor-grab active:cursor-grabbing hover:brightness-105 mt-3 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-n-brand"
    :class="[
      { 'scale-[1.02] shadow-xl opacity-90': isDragging },
      {
        '!mt-2 !rounded-xl !border-n-weak !bg-n-solid-1 !p-4 text-[13px] hover:!bg-n-alpha-1 hover:!brightness-100':
          isWorkspaceV2,
      },
      // SLA estourado: faixa na borda esquerda, NUNCA preenchendo o cartão.
      // Regra do design system travada em 2026-08-09: cor semântica só em
      // ícone/ponto/borda. Aqui havia um fundo rosa em hex cru, pensado para
      // tema claro — no dark a coluna inteira ficava vermelha, e com muitos
      // itens fora do prazo o sinal deixava de significar alguma coisa.
      // O selo 'SLA Perdido' logo abaixo continua sendo o rótulo explícito.
      isStageSlaBreached ? 'border-l-[3px] border-l-n-ruby-9' : '',
      // Urgente sem SLA estourado: contorno tracejado (também por token, não hex)
      isUrgent && !isStageSlaBreached ? 'border-dashed border-n-ruby-8' : '',
      isCardSelected ? 'ring-2 ring-n-blue-9 border-n-blue-9' : '',
    ]"
    :draggable="draggable && canEditItem"
    tabindex="0"
    role="group"
    :aria-label="props.item.item_details?.title || t('KANBAN.UNTITLED_ITEM')"
    @keydown.enter="handleCardKeydown"
    @dragstart="handleDragStart"
    @dragend="handleDragEnd"
    @click="handleClick"
    @contextmenu="handleContextMenu"
  >
    <div class="flex items-start justify-between mb-3 gap-2">
      <div class="flex items-start gap-2 min-w-0 flex-1">
        <button
          type="button"
          class="mt-0.5 flex size-4 shrink-0 items-center justify-center rounded border transition-opacity focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-n-blue-9"
          :class="[
            isCardSelected
              ? 'border-n-blue-9 bg-n-blue-9 text-white opacity-100'
              : 'border-n-strong text-transparent',
            isCardSelected || hasCardSelection
              ? 'opacity-100'
              : 'opacity-0 focus-visible:opacity-100 group-hover:opacity-100',
          ]"
          role="checkbox"
          :aria-checked="isCardSelected"
          :aria-label="t('KANBAN.SELECTION_BAR.SELECT_CARD', { name: itemTitle })"
          :title="t('KANBAN.SELECTION_BAR.SELECT_CARD', { name: itemTitle })"
          data-testid="kanban-item-select"
          @click="handleSelectionToggle"
          @mousedown.stop
        >
          <span class="i-ph-check size-3" aria-hidden="true" />
        </button>
        <!-- Avatar do contato -->
        <Avatar
          v-if="contactAvatar"
          :src="contactAvatar"
          :name="itemTitle"
          :size="24"
        />

        <div class="flex min-w-0 flex-1 flex-wrap items-start gap-x-2 gap-y-1">
          <!-- Título ocupa a linha inteira e quebra em até 2 linhas. Antes
               era cortado em 15 caracteres para dividir a linha com idade,
               status e menu, que agora vivem no rodapé do card. -->
          <h3
            class="min-w-0 flex-1 basis-full line-clamp-2 break-words text-[13px] font-medium text-n-slate-12"
            :class="{ '!text-[15px] !font-bold': isWorkspaceV2 }"
            :title="itemTitle"
          >
            {{ itemTitle }}
          </h3>
          <!-- Phase 2.9.8 I: badge de lead profile (hot/warm/cold) via voip_summary -->
          <span
            v-if="voipProfileBadge"
            class="inline-flex items-center gap-0.5 px-1.5 py-0.5 rounded-full text-[10px] font-medium border"
            :class="voipProfileBadge.color"
            :title="`VOIP lead profile: ${voipProfileBadge.label}`"
          >
            {{ voipProfileBadge.icon }} {{ voipProfileBadge.label }}
          </span>
          <span
            v-if="voipSummary?.score"
            class="inline-flex items-center px-1.5 py-0.5 rounded-full text-[10px] font-medium text-n-slate-12 bg-n-solid-2 border border-n-weak"
            :title="`Lead Scoring: ${voipSummary.score}`"
          >
            ⚡{{ voipSummary.score }}
          </span>
          <span
            v-if="isStageSlaBreached"
            class="shrink-0 text-[11px] font-semibold text-n-ruby-11"
          >
            SLA Perdido
          </span>
          <div
            v-if="hasLocationData"
            v-tooltip.top="t('KANBAN.BASIC_DATA_PANEL.LOCATION_SAVED_A11Y')"
            class="flex shrink-0 items-center text-n-slate-11"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="14"
              height="14"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
              class="shrink-0"
              role="img"
              :aria-label="t('KANBAN.BASIC_DATA_PANEL.LOCATION_SAVED_A11Y')"
            >
              <path
                d="M20 10c0 4.993-5.539 10.193-7.399 11.799a1 1 0 0 1-1.202 0C9.539 20.193 4 14.993 4 10a8 8 0 0 1 16 0"
              />
              <path d="m9 10 2 2 4-4" />
            </svg>
          </div>
        </div>
      </div>
      <div class="flex items-center gap-2 flex-shrink-0">
        <div class="flex items-center gap-2">
          <!-- Tempo na etapa (só no card com template; no layout padrão ele
               desceu para o rodapé, junto do status) -->
          <div
            v-if="timeInStage && hasCardTemplate && cardDisplay.timeInStage"
            v-tooltip.top="t('KANBAN.TIME_IN_STAGE_TOOLTIP')"
            class="flex items-center gap-1"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="12"
              height="12"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
              class="text-n-slate-11 flex-shrink-0"
            >
              <path d="M12 6v6l4 2" />
              <circle cx="12" cy="12" r="10" />
            </svg>
            <span
              class="text-[11px] font-medium text-n-slate-11"
              :class="{ '!text-xs': isWorkspaceV2 }"
            >
              {{ timeInStage }}
            </span>
          </div>

          <!-- Status Badge (card com template; no layout padrão o controle
               de status virou ponto colorido no rodapé, mostrado uma vez só) -->
          <button
            v-if="!isSharedRecipient && hasCardTemplate"
            v-tooltip.top="t('KANBAN.TOOLTIPS.STATUS_BADGE_CLICK')"
            class="px-2 py-1 text-xs font-medium rounded-full flex items-center gap-1 transition-colors"
            :class="{ '!min-h-8 !px-2.5 !text-[13px]': isWorkspaceV2 }"
            :style="getStatusBadgeStyle()"
            @click.stop="handleStatusClick"
          >
            <svg
              v-if="
                props.item.item_details?.status === 'won' ||
                props.item.item_details?.status === 'lost' ||
                conversationData?.status === 'resolved'
              "
              xmlns="http://www.w3.org/2000/svg"
              width="12"
              height="12"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
              class="w-3 h-3"
            >
              <polyline points="20 6 9 17 4 12" />
            </svg>
            <span>
              {{ displayedStatus }}
            </span>
            <PriorityCircle
              v-if="
                showPriorityField &&
                props.item.item_details?.priority &&
                props.item.item_details.priority !== 'none'
              "
              :priority="props.item.item_details.priority"
              :size="14"
              class="ml-1"
            />
          </button>

          <!-- More Options Button -->
          <div class="relative">
            <button
              v-tooltip.top="t('KANBAN.TOOLTIPS.MORE_OPTIONS_CLICK')"
              type="button"
              class="inline-flex items-center justify-center size-6 -m-1 rounded-md cursor-pointer focus-visible:outline focus-visible:outline-2 focus-visible:outline-n-brand [@media(pointer:coarse)]:size-11 [@media(pointer:coarse)]:-m-3"
              :aria-label="t('KANBAN.ITEM_PANEL.MORE_OPTIONS')"
              aria-haspopup="menu"
              :aria-expanded="showOptionsMenu"
              @click.stop="
                showOptionsMenu = !showOptionsMenu;
                showContextMenu = false;
              "
            >
              <span
                class="i-ri-more-2-line size-4 text-n-slate-11 hover:text-n-slate-12 transition-colors"
                aria-hidden="true"
              />
            </button>

            <!-- Menu de Opções -->
            <div
              v-if="showOptionsMenu"
              class="absolute right-0 top-full mt-1 bg-n-solid-1 rounded-md shadow-lg border border-n-weak w-[170px] min-w-[140px] flex flex-col gap-1 z-10"
              style="box-shadow: 0 4px 24px 0 rgba(30, 41, 59, 0.08)"
              @click.stop
            >
              <button
                v-if="canEditItem"
                class="w-full px-3 py-1.5 text-left text-xs font-normal hover:bg-n-alpha-2 text-n-slate-12 rounded-none transition-colors"
                @click.stop="handleEdit($event)"
              >
                <span class="flex items-center gap-2">
                  <span class="i-ri-pencil-line size-4" />
                  {{ t('KANBAN.ACTIONS.EDIT') }}
                </span>
              </button>
              <KanbanMoveToStageMenu
                v-if="canEditItem"
                :current-stage="item.funnel_stage"
                @move="handleMoveToStage"
              />
              <button
                class="w-full px-3 py-1.5 text-left text-xs font-normal hover:bg-n-alpha-2 text-n-slate-12 rounded-none transition-colors"
                @click.stop="shareCopyLink"
              >
                <span class="flex items-center gap-2">
                  <span class="i-ph-link size-4" />
                  {{ t('KANBAN_SHARING.MENU.COPY_LINK') }}
                </span>
              </button>
              <button
                v-if="canSendCardOnInternalChat"
                class="w-full px-3 py-1.5 text-left text-xs font-normal hover:bg-n-alpha-2 text-n-slate-12 rounded-none transition-colors"
                @click.stop="shareOpenSend"
              >
                <span class="flex items-center gap-2">
                  <span class="i-ph-paper-plane-tilt size-4" />
                  {{ t('KANBAN_SHARING.MENU.SEND_INTERNAL_CHAT') }}
                </span>
              </button>
              <button
                v-if="item.access?.can_manage === true"
                class="w-full px-3 py-1.5 text-left text-xs font-normal hover:bg-n-alpha-2 text-n-slate-12 rounded-none transition-colors"
                @click.stop="shareOpenManage"
              >
                <span class="flex items-center gap-2">
                  <span class="i-ph-lock-key size-4" />
                  {{ t('KANBAN_SHARING.MENU.MANAGE_ACCESS') }}
                </span>
              </button>
              <button
                v-if="isStacklab === true && !isSharedRecipient"
                class="w-full px-3 py-1.5 text-left text-xs font-normal hover:bg-n-alpha-2 text-n-slate-12 rounded-none transition-colors"
                @click.stop="handleVisibilityClick"
              >
                <span class="flex items-center gap-2">
                  <span class="i-ri-eye-line size-4" />
                  {{ t('KANBAN.CONTEXT_MENU.CUSTOMIZE_FIELDS.TITLE') }}
                </span>
              </button>
              <button
                class="w-full px-3 py-1.5 text-left text-xs font-normal hover:bg-n-alpha-2 text-n-slate-12 rounded-none transition-colors"
                @click.stop="toggleCollapseItem"
              >
                <span class="flex items-center gap-2">
                  <fluent-icon
                    :icon="isItemCollapsed ? 'arrow-expand' : 'arrow-outwards'"
                    size="16"
                  />
                  {{
                    isItemCollapsed
                      ? t('KANBAN.CONTEXT_MENU.EXPAND')
                      : t('KANBAN.CONTEXT_MENU.COLLAPSE')
                  }}
                </span>
              </button>
              <button
                v-if="!isSharedRecipient"
                class="w-full px-3 py-1.5 text-left text-xs font-normal hover:bg-n-alpha-2 text-n-slate-12 rounded-none transition-colors"
                @click.stop="handleDuplicate($event)"
              >
                <span class="flex items-center gap-2">
                  <span class="i-ri-file-copy-line size-4" />
                  {{ t('KANBAN.QUICK_ACTIONS_DESCRIPTIONS.DUPLICATE') }}
                </span>
              </button>
              <KanbanCardTemplateSelector
                v-if="canEditItem"
                :item="item"
                :open="showOptionsMenu"
              />
              <button
                v-if="!isSharedRecipient"
                class="w-full px-3 py-1.5 text-left text-xs font-normal hover:bg-n-alpha-2 text-n-slate-12 rounded-none transition-colors"
                @click.stop="handleDelete($event)"
              >
                <span class="flex items-center gap-2">
                  <span class="i-ri-delete-bin-line size-4" />
                  {{ t('KANBAN.ACTIONS.DELETE') }}
                </span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Faixa do próximo passo. Fica fora do v-if/v-else do template de card
         de propósito: a conta que configurou template continua com o template,
         e ganha a faixa do mesmo jeito. Verde quando há próximo passo futuro,
         vermelha quando atrasado, tracejada quando não há nenhum. -->
    <button
      v-if="showNextStepBand"
      type="button"
      class="mt-1 mb-3 flex w-full items-center gap-2 rounded-lg border px-2.5 py-1.5 text-left text-[12px] font-semibold transition-colors"
      :class="[
        nextStepBandClass,
        nextStepBadge.tone === 'none' ? '!font-medium hover:bg-n-alpha-1' : '',
      ]"
      :aria-label="
        nextStepBadge.tone === 'none'
          ? t('KANBAN.NEXT_STEP.EMPTY_ARIA')
          : t('KANBAN.NEXT_STEP.OPEN_ARIA')
      "
      :title="nextStepBadge.labelParams.title || nextStepLabel"
      data-testid="kanban-card-next-step"
      @click.stop="handleNextStepClick"
    >
      <span :class="[nextStepBadge.icon, 'size-4 shrink-0']" aria-hidden="true" />
      <span class="min-w-0 flex-1 truncate">{{ nextStepLabel }}</span>
    </button>

    <KanbanCardTemplateRenderer
      v-if="hasCardTemplate"
      :item="item"
      surface="face"
    />

    <template v-else-if="!isSharedRecipient">
    <!-- Phase 2.9.8 G: info compacta da ultima chamada VOIP -->
    <div
      v-if="voipLastCallLabel && !isItemCollapsed"
      class="flex items-center gap-1 mb-2 px-2 py-1 rounded text-[10px] text-n-slate-11 bg-n-solid-2/50 border border-n-weak"
      title="Última chamada VOIP"
    >
      <span class="shrink-0">📞</span>
      <span class="truncate">{{ voipLastCallLabel }}</span>
    </div>

    <div
      v-if="cardDisplay.description && props.item.item_details?.description"
      class="text-[11px] text-n-slate-11 mb-3"
      :class="{ '!text-[13px] !leading-relaxed': isWorkspaceV2 }"
    >
      <div
        class="prose prose-sm max-w-none dark:prose-invert"
        v-html="truncatedDescription"
      />
      <span
        v-if="isDescriptionTruncated"
        class="text-[10px] font-medium text-woot-500 dark:text-woot-400 hover:underline cursor-pointer inline-block mt-1"
        @click="toggleDescription"
      >
        {{
          showFullDescription ? t('KANBAN.READ_LESS') : t('KANBAN.READ_MORE')
        }}
      </span>
    </div>

    <!-- Informação da Conversa (quando houver conversa vinculada) -->
    <AgentTooltip text="Clique com o botão direito para ver mais opções.">
      <div
        v-if="
          cardDisplay.conversationPreview &&
          !isItemCollapsed &&
          item.item_details?.conversation_id &&
          conversationData
        "
        class="flex items-center gap-2 mb-3 px-3.5 py-1.5 bg-n-solid-1 rounded-md shadow-lg border border-n-weak min-h-[1.5rem] cursor-pointer transition-colors text-xs conversation-card-gradient"
        :class="{
          '!rounded-xl !bg-n-alpha-1 !px-3 !py-2 !text-[13px] !shadow-none hover:!bg-n-alpha-2':
            isWorkspaceV2,
        }"
        :style="{
          boxShadow: '0 4px 24px 0 rgba(30,41,59,0.08)',
          background: isConversationCardHovered
            ? `linear-gradient(90deg, rgb(var(--${conversationStatusTone}-3) / 0.6) 0%, transparent 100%)`
            : '',
        }"
        @mouseenter="isConversationCardHovered = true"
        @mouseleave="isConversationCardHovered = false"
        @click="navigateToConversation($event, item.conversation?.display_id)"
      >
        <div class="flex items-center gap-1">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="12"
            height="12"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
            class="text-n-slate-10 flex-shrink-0"
          >
            <path
              d="M2.992 16.342a2 2 0 0 1 .094 1.167l-1.065 3.29a1 1 0 0 0 1.236 1.168l3.413-.998a2 2 0 0 1 1.099.092 10 10 0 1 0-4.777-4.719"
            />
          </svg>
          <span class="text-[10px] text-n-slate-10 select-all px-1 py-0.5">{{
            conversationData.display_id
          }}</span>
        </div>
        <div class="flex items-center justify-between flex-1 min-w-0">
          <div class="flex items-center gap-1 min-w-0 flex-1">
            <span class="truncate font-semibold text-n-slate-12">{{
              conversationData.campaign_name
            }}</span>
            <span class="truncate text-n-slate-11">{{
              truncatedSenderName
            }}</span>
            <!-- Última mensagem -->
            <span
              v-if="conversationData.last_message"
              class="truncate text-xs text-n-slate-10 ml-2"
              :title="conversationData.last_message.content"
            >
              "{{ truncatedLastMessage }}"
            </span>
          </div>
          <span
            v-if="showConversationStatus"
            class="text-[11px] px-2 py-0.5 rounded-full border border-n-weak flex-shrink-0"
            :style="{
              background: conversationStatusBadgeStyle.background,
              color: conversationStatusBadgeStyle.color,
              boxShadow: '0 2px 8px 0 rgba(30,41,59,0.04)',
              border: conversationStatusBadgeStyle.border,
            }"
          >
            {{ conversationStatusLabel }}
          </span>
        </div>
      </div>
    </AgentTooltip>

    <!-- Placeholder de conversa vinculada (quando NÃO houver conversa) -->
    <AgentTooltip text="Clique para vincular uma conversa a este item.">
      <div
        v-if="
          cardDisplay.conversationPreview &&
          !isItemCollapsed &&
          !item.item_details?.conversation_id
        "
        class="flex items-center gap-2 mb-3 px-3.5 py-1.5 bg-n-solid-1 rounded-md shadow-lg border border-dashed border-n-weak min-h-[1.5rem] cursor-pointer transition-colors text-xs"
        style="box-shadow: 0 4px 24px 0 rgba(30, 41, 59, 0.08)"
        @click.stop="handleLinkConversation"
      >
        <div class="flex items-center gap-1">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="12"
            height="12"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
            class="text-n-slate-10 flex-shrink-0"
          >
            <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h9" />
            <path d="M16 3h5v5" />
            <path d="M10 14L21 3" />
          </svg>
        </div>
        <div class="flex items-center justify-between flex-1 min-w-0">
          <span class="truncate font-medium text-n-slate-11">
            Vincular conversa
          </span>
        </div>
      </div>
    </AgentTooltip>

    <!-- Labels da conversa vinculada -->
    <div
      v-if="
        cardDisplay.labels && !isItemCollapsed && conversationLabels.length > 0
      "
      class="flex flex-wrap gap-1 mb-3"
    >
      <span
        v-for="label in conversationLabels.slice(0, 3)"
        :key="label"
        class="inline-flex items-center px-2 py-0.5 rounded-md text-xs font-normal bg-n-solid-1 border border-n-weak text-n-slate-12"
        style="
          box-shadow: 0 2px 8px 0 rgba(30, 41, 59, 0.04);
          min-width: max-content;
        "
      >
        {{ label }}
      </span>
      <span
        v-if="conversationLabels.length > 3"
        class="inline-flex items-center px-2 py-0.5 rounded-md text-xs font-normal bg-n-solid-2 border border-n-weak text-n-slate-12"
        style="
          box-shadow: 0 2px 8px 0 rgba(30, 41, 59, 0.04);
          min-width: max-content;
        "
      >
        +{{ conversationLabels.length - 3 }}
      </span>
    </div>

    <!-- Progress Bar do Checklist -->
    <div
      v-if="showChecklistField && !isItemCollapsed && totalItems > 0"
      class="flex flex-col gap-1.5 mb-3"
    >
      <div class="flex items-center gap-2">
        <div class="flex-1">
          <div class="h-1.5 bg-n-alpha-2 rounded-full overflow-hidden">
            <div
              class="h-full bg-woot-500 transition-all duration-300 ease-out"
              :style="{ width: `${checklistProgress}%` }"
            />
          </div>
        </div>
        <span class="text-xs text-n-slate-11">
          {{ completedItems }}/{{ totalItems }}
        </span>
      </div>

      <!-- Sugestão de Próxima Ação -->
      <div
        v-if="nextChecklistItem"
        class="group mt-0.5 px-2 py-1.5 rounded-md border border-n-weak/80 bg-n-solid-2 flex items-start gap-2 transition-colors duration-150 hover:bg-n-alpha-2/60 hover:border-n-strong cursor-pointer"
        :class="{
          '!rounded-xl !bg-transparent !px-3 !py-2': isWorkspaceV2,
        }"
        @click="openItemDetailWithTab($event, 'checklist')"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="14"
          height="14"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
          class="lucide lucide-list-todo-icon flex-shrink-0 mt-0.5 text-n-slate-10 transition-colors duration-150 group-hover:text-n-slate-11"
        >
          <path d="M13 5h8" />
          <path d="M13 12h8" />
          <path d="M13 19h8" />
          <path d="m3 17 2 2 4-4" />
          <rect x="3" y="4" width="6" height="6" rx="1" />
        </svg>
        <div class="flex flex-col min-w-0">
          <span
            class="text-[11px] font-medium text-n-slate-11 uppercase tracking-wide"
          >
            {{ $t('KANBAN.FORM.CHECKLIST.NEXT_ACTION_TITLE') + ' (Checklist)' }}
          </span>
          <span
            class="text-xs text-n-slate-12 truncate"
            :class="{ '!text-[13px]': isWorkspaceV2 }"
            :title="nextChecklistItem?.text"
          >
            {{ nextChecklistItem?.text }}
          </span>
        </div>
      </div>
    </div>

    <div class="flex items-center justify-between gap-2">
      <div class="flex items-center gap-2 min-w-0">
        <!-- Status do item: ponto colorido + rótulo, discreto e ainda
             clicável. É a única aparição do status no card padrão. -->
        <button
          v-if="!isSharedRecipient"
          v-tooltip.top="t('KANBAN.TOOLTIPS.STATUS_BADGE_CLICK')"
          class="flex flex-shrink-0 items-center gap-1.5 text-[11px] font-medium text-n-slate-11 hover:text-n-slate-12 transition-colors"
          @click.stop="handleStatusClick"
        >
          <span
            class="size-2 rounded-full flex-shrink-0"
            :class="statusDotClass"
          />
          <span>{{ displayedStatus }}</span>
          <PriorityCircle
            v-if="
              showPriorityField &&
              props.item.item_details?.priority &&
              props.item.item_details.priority !== 'none'
            "
            :priority="props.item.item_details.priority"
            :size="12"
          />
        </button>

        <!-- Tempo parado na etapa -->
        <div
          v-if="timeInStage && cardDisplay.timeInStage"
          v-tooltip.top="t('KANBAN.TIME_IN_STAGE_TOOLTIP')"
          class="flex flex-shrink-0 items-center gap-1 text-[11px] font-medium text-n-slate-11"
        >
          <span class="i-ri-time-line size-3" />
          <span>{{ timeInStage }}</span>
        </div>
      </div>
      <div
        v-if="cardDisplay.assignee && !isItemCollapsed && item.item_details"
        class="flex items-center gap-2"
      >
        <div class="flex items-center gap-2">
          <!-- Agentes com sobreposição -->
          <div class="flex items-center">
            <AgentTooltip
              v-if="primaryAgent"
              :text="primaryAgent.name"
              placement="bottom"
              class="flex items-center relative"
            >
              <div>
                <Avatar
                  :name="primaryAgent.name"
                  :src="primaryAgent.avatar_url"
                  :size="24"
                  class="flex-shrink-0 cursor-pointer"
                  @click.stop="openAgentAssignModal"
                />
              </div>
            </AgentTooltip>

            <!-- Agentes Adicionais com sobreposição -->
            <AgentTooltip
              v-for="(agent, idx) in agentInfo.slice(1, 3)"
              :key="agent.id"
              :text="`${agent.name} (clique para remover)`"
              placement="bottom"
              class="flex items-center -ml-2 relative"
              :class="idx === 0 ? 'z-0' : 'z-[1]'"
            >
              <Avatar
                :name="agent.name"
                :src="agent.avatar_url"
                :size="24"
                class="flex-shrink-0 cursor-pointer hover:opacity-75 transition-opacity"
                @click.stop="removeAgent(agent.id)"
              />
            </AgentTooltip>

            <!-- Indicador de mais agentes -->
            <div
              v-if="additionalAgentsCount > 2"
              v-tooltip.top="t('KANBAN.TOOLTIPS.ADD_AGENT_CLICK')"
              class="flex items-center justify-center w-6 h-6 bg-n-alpha-2 rounded-full text-xs font-medium text-n-slate-11 cursor-pointer hover:bg-n-alpha-3 transition-colors -ml-2 relative z-0"
              @click.stop="openAgentAssignModal"
            >
              +{{ additionalAgentsCount - 2 }}
            </div>
          </div>

          <!-- Ícone de mais para abrir modal de agentes -->
          <div
            v-if="primaryAgent"
            v-tooltip.top="t('KANBAN.TOOLTIPS.ADD_AGENT_CLICK')"
            class="opacity-0 group-hover:opacity-100 flex items-center justify-center w-6 h-6 bg-n-solid-2 rounded-full cursor-pointer hover:bg-n-alpha-2 transition-all flex-shrink-0 translate-y-px"
            @click.stop="openAgentAssignModal"
          >
            <span class="i-ri-add-line size-3 text-n-slate-11" />
          </div>

          <!-- Botão para adicionar agente quando não há nenhum (sempre visível) -->
          <div
            v-if="!primaryAgent"
            v-tooltip.top="t('KANBAN.TOOLTIPS.ADD_AGENT_CLICK')"
            class="flex items-center justify-center w-6 h-6 bg-n-solid-2 rounded-full cursor-pointer hover:bg-n-alpha-2 transition-all"
            @click.stop="openAgentAssignModal"
          >
            <span class="i-ri-user-add-line size-3 text-n-slate-11" />
          </div>
        </div>
      </div>

      <!-- Substituir a data pelos ícones -->
      <div
        v-if="showMetadataField"
        class="flex items-center gap-2 text-xs text-n-slate-11"
      >
        <div
          v-if="
            isItemCollapsed &&
            cardDisplay.conversationPreview &&
            item.item_details?.conversation_id &&
            conversationData
          "
          class="flex items-center gap-1"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="12"
            height="12"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
            class="text-n-slate-10 flex-shrink-0"
          >
            <path
              d="M2.992 16.342a2 2 0 0 1 .094 1.167l-1.065 3.29a1 1 0 0 0 1.236 1.168l3.413-.998a2 2 0 0 1 1.099.092 10 10 0 1 0-4.777-4.719"
            />
          </svg>
          <span class="text-[10px] text-n-slate-11">
            #{{ conversationData.display_id ?? conversationData.id }}
          </span>
        </div>
        <div v-else-if="isItemCollapsed" class="flex items-center gap-1">
          <span class="i-ri-arrow-right-up-line size-3" />
        </div>
        <!-- Tempo movido para o cabeçalho -->
        <div v-if="attachmentsCount > 0" class="flex items-center gap-1">
          <span class="i-ri-attachment-line size-3" />
          {{ attachmentsCount }}
        </div>
        <div v-if="notesCount > 0" class="flex items-center gap-1">
          <span class="i-ri-chat-new-line size-3" />
          {{ notesCount }}
        </div>

        <!-- Valor do offer -->
        <div
          v-if="cardDisplay.value && formattedValue"
          class="flex items-center gap-1 ml-2"
        >
          <span class="text-[11px] font-medium text-n-slate-11">
            {{ formattedValue }}
          </span>
        </div>

        <!-- Data de agendamento -->
        <div
          v-if="showDeadlineField && formattedDeadline && !isItemCollapsed"
          class="flex items-center gap-1 ml-2"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="12"
            height="12"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
            class="text-n-slate-11 flex-shrink-0"
          >
            <path d="M8 2v4" />
            <path d="M16 2v4" />
            <rect width="18" height="18" x="3" y="4" rx="2" />
            <path d="M3 10h18" />
            <path d="m9 16 2 2 4-4" />
          </svg>
          <span class="text-[11px] font-medium text-n-slate-11">
            {{ formattedDeadline }}
          </span>
        </div>
      </div>
    </div>
    </template>
  </div>

  <!-- Adicionar o ContextMenu -->
  <CustomContextMenu
    v-if="showContextMenu && isItemVisible"
    :x="contextMenuPosition.x"
    :y="contextMenuPosition.y"
    :show="showContextMenu"
    @close="showContextMenu = false"
  >
    <div
      class="bg-n-solid-1 rounded-md shadow-lg border border-n-weak w-[170px] min-w-[140px] flex flex-col gap-1"
      style="box-shadow: 0 4px 24px 0 rgba(30, 41, 59, 0.08)"
    >
      <button
        v-if="canEditItem"
        class="w-full px-3 py-1.5 text-left text-xs font-normal hover:bg-n-alpha-2 text-n-slate-12 rounded-none transition-colors"
        @click.stop="handleEdit($event)"
      >
        <span class="flex items-center gap-2">
          <span class="i-ri-pencil-line size-4" />
          {{ t('KANBAN.ACTIONS.EDIT') }}
        </span>
      </button>
      <KanbanMoveToStageMenu
        v-if="canEditItem"
        :current-stage="item.funnel_stage"
        @move="handleMoveToStage"
      />
      <button
        class="w-full px-3 py-1.5 text-left text-xs font-normal hover:bg-n-alpha-2 text-n-slate-12 rounded-none transition-colors"
        @click.stop="shareCopyLink"
      >
        <span class="flex items-center gap-2">
          <span class="i-ph-link size-4" />
          {{ t('KANBAN_SHARING.MENU.COPY_LINK') }}
        </span>
      </button>
      <button
        v-if="canSendCardOnInternalChat"
        class="w-full px-3 py-1.5 text-left text-xs font-normal hover:bg-n-alpha-2 text-n-slate-12 rounded-none transition-colors"
        @click.stop="shareOpenSend"
      >
        <span class="flex items-center gap-2">
          <span class="i-ph-paper-plane-tilt size-4" />
          {{ t('KANBAN_SHARING.MENU.SEND_INTERNAL_CHAT') }}
        </span>
      </button>
      <button
        v-if="item.access?.can_manage === true"
        class="w-full px-3 py-1.5 text-left text-xs font-normal hover:bg-n-alpha-2 text-n-slate-12 rounded-none transition-colors"
        @click.stop="shareOpenManage"
      >
        <span class="flex items-center gap-2">
          <span class="i-ph-lock-key size-4" />
          {{ t('KANBAN_SHARING.MENU.MANAGE_ACCESS') }}
        </span>
      </button>
      <button
        v-if="isStacklab === true && !isSharedRecipient"
        class="w-full px-3 py-1.5 text-left text-xs font-normal hover:bg-n-alpha-2 text-n-slate-12 rounded-none transition-colors"
        @click.stop="handleVisibilityClick"
      >
        <span class="flex items-center gap-2">
          <span class="i-ri-eye-line size-4" />
          {{ t('KANBAN.CONTEXT_MENU.CUSTOMIZE_FIELDS.TITLE') }}
        </span>
      </button>
      <button
        class="w-full px-3 py-1.5 text-left text-xs font-normal hover:bg-n-alpha-2 text-n-slate-12 rounded-none transition-colors"
        @click.stop="toggleCollapseItem"
      >
        <span class="flex items-center gap-2">
          <fluent-icon
            :icon="isItemCollapsed ? 'arrow-expand' : 'arrow-outwards'"
            size="16"
          />
          {{
            isItemCollapsed
              ? t('KANBAN.CONTEXT_MENU.EXPAND')
              : t('KANBAN.CONTEXT_MENU.COLLAPSE')
          }}
        </span>
      </button>
      <button
        v-if="!isSharedRecipient"
        class="w-full px-3 py-1.5 text-left text-xs font-normal hover:bg-n-alpha-2 text-n-slate-12 rounded-none transition-colors"
        @click.stop="handleDuplicate($event)"
      >
        <span class="flex items-center gap-2">
          <span class="i-ri-file-copy-line size-4" />
          {{ t('KANBAN.QUICK_ACTIONS_DESCRIPTIONS.DUPLICATE') }}
        </span>
      </button>
      <KanbanCardTemplateSelector
        v-if="canEditItem"
        :item="item"
        :open="showContextMenu"
      />
      <button
        v-if="!isSharedRecipient"
        class="w-full px-3 py-1.5 text-left text-xs font-normal hover:bg-n-alpha-2 text-n-slate-12 rounded-none transition-colors"
        @click.stop="handleDelete($event)"
      >
        <span class="flex items-center gap-2">
          <span class="i-ri-delete-bin-line size-4" />
          {{ t('KANBAN.ACTIONS.DELETE') }}
        </span>
      </button>

      <!-- Opção para vincular conversa quando não houver conversa vinculada -->
      <button
        v-if="!isSharedRecipient && !item.item_details?.conversation_id"
        class="w-full px-3 py-1.5 text-left text-xs font-normal hover:bg-n-alpha-2 text-n-slate-12 rounded-none transition-colors"
        @click.stop="handleLinkConversation"
      >
        <span class="flex items-center gap-2">
          <span class="i-ri-link size-4" />
          {{ t('KANBAN.CONTEXT_MENU.LINK_CONVERSATION') }}
        </span>
      </button>

      <!-- Separador se houver conversa -->
      <div
        v-if="!isSharedRecipient && conversationData"
        class="h-px bg-n-solid-2 my-1 mx-2"
      />

      <button
        v-if="!isSharedRecipient && conversationData && isStacklab === true"
        class="w-full px-3 py-1.5 text-left text-xs font-normal hover:bg-n-alpha-2 text-n-slate-12 rounded-none transition-colors"
        @click.stop="handleQuickMessage"
      >
        <span class="flex items-center gap-2">
          <span class="i-ri-chat-1-line size-4" />
          {{ t('KANBAN.CONTEXT_MENU.QUICK_MESSAGE') }}
        </span>
      </button>
      <button
        v-if="!isSharedRecipient && conversationData"
        class="w-full px-3 py-1.5 text-left text-xs font-normal hover:bg-n-alpha-2 text-n-slate-12 rounded-none transition-colors"
        @click.stop="handleScheduleMessage"
      >
        <span class="flex items-center gap-2">
          <span class="i-ri-calendar-line size-4" />
          {{ t('KANBAN.CONTEXT_MENU.SCHEDULE_MESSAGE') }}
        </span>
      </button>
      <button
        v-if="!isSharedRecipient && conversationData"
        class="w-full px-3 py-1.5 text-left text-xs font-normal hover:bg-n-alpha-2 text-n-slate-12 rounded-none transition-colors"
        @click.stop="handleViewContact"
      >
        <span class="flex items-center gap-2">
          <span class="i-ri-user-line size-4" />
          {{ t('KANBAN.CONTEXT_MENU.VIEW_CONTACT') }}
        </span>
      </button>
      <button
        v-if="!isSharedRecipient && conversationData"
        class="w-full px-3 py-1.5 text-left text-xs font-normal hover:bg-n-alpha-2 text-n-slate-12 rounded-none transition-colors"
        @click.stop="handleLinkConversation"
      >
        <span class="flex items-center gap-2">
          <span class="i-ri-arrow-left-right-line size-4" />
          {{ t('KANBAN.CONTEXT_MENU.CHANGE_LINKED_CONVERSATION') }}
        </span>
      </button>
    </div>
  </CustomContextMenu>

  <!-- Compartilhar: os diálogos vivem na raiz do cartão, fora dos menus.
       Dentro deles morreriam junto com o menu no primeiro clique fora. -->
  <KanbanShareButton
    ref="shareControlRef"
    variant="headless"
    :item-id="item.id"
    :item-title="item.item_details?.title || item.title"
    :item="item"
    :can-manage="item.access?.can_manage === true"
  />

  <!-- Modal de Mensagem Rápida -->
  <Modal
    v-if="isItemVisible"
    v-model:show="showSendMessageModal"
    :on-close="() => (showSendMessageModal = false)"
    :show-close-button="true"
    size="medium"
    :close-on-backdrop-click="false"
    :class="{ 'z-50': showSendMessageModal }"
  >
    <div class="settings-modal">
      <header class="settings-header">
        <h3 class="text-lg font-medium">
          {{ t('KANBAN.SEND_MESSAGE.TITLE') }}
        </h3>
      </header>

      <div class="settings-content">
        <SendMessageTemplate
          :conversation-id="conversationData?.display_id"
          :current-stage="item.funnel_stage || ''"
          :contact="conversationData?.contact"
          :conversation="conversationData"
          :item="item"
          @close="
            () => {
              showSendMessageModal = false;
              showContextMenu.value = false;
            }
          "
          @send="showSendMessageModal = false"
        />
      </div>
    </div>
  </Modal>

  <ScheduleMessageModal
    v-if="
      showScheduleMessageModal &&
      (conversationData?.display_id != null || conversationData?.id)
    "
    :show="showScheduleMessageModal"
    :conversation-id="conversationData.display_id ?? conversationData.id"
    @close="showScheduleMessageModal = false"
  />

  <!-- Modal para vincular conversa -->
  <Modal
    v-if="isItemVisible"
    v-model:show="showLinkConversationModal"
    :on-close="() => (showLinkConversationModal = false)"
    :show-close-button="true"
    size="medium"
  >
    <div class="settings-modal">
      <header class="settings-header">
        <h3 class="text-lg font-medium">
          {{ t('KANBAN.FORM.CONVERSATION.TITLE') }}
        </h3>
      </header>

      <div class="settings-content space-y-4">
        <!-- Modo 1: Vincular conversa existente -->
        <template v-if="!isNewConversationMode">
          <p class="text-sm text-n-slate-11">
            {{ t('KANBAN.FORM.CONVERSATION.HAS_CONVERSATION') }}
          </p>

          <input
            v-model="conversationSearch"
            type="text"
            class="w-full px-3 py-2 border border-n-weak rounded-md text-sm bg-n-solid-2 focus:ring-2 focus:ring-woot-500/20 focus:border-woot-500 disabled:opacity-50 disabled:cursor-not-allowed"
            :disabled="loadingConversations"
            :placeholder="t('KANBAN.SEARCH_CONVERSATION')"
          />

          <div class="border border-n-weak rounded-md max-h-64 overflow-y-auto">
            <div
              v-if="loadingConversations"
              class="flex flex-col items-center justify-center gap-3 py-10 text-n-slate-11 text-sm"
            >
              <Spinner class="text-n-brand" />
              <span>{{ t('KANBAN.LOADING_CONVERSATION') }}</span>
            </div>
            <div
              v-else-if="filteredConversations.length === 0"
              class="flex items-center justify-center py-6 text-n-slate-10 text-sm"
            >
              {{ t('KANBAN.NO_CONVERSATIONS_FOUND') }}
            </div>
            <div v-else class="divide-y divide-n-weak">
              <button
                v-for="conversation in filteredConversations"
                :key="conversation.id"
                type="button"
                class="w-full px-3 py-2 flex items-center gap-2 text-left text-sm hover:bg-n-alpha-2 transition-colors"
                :class="{
                  'bg-woot-50 dark:bg-woot-900/30':
                    selectedConversationId === conversation.id,
                }"
                @click="selectedConversationId = conversation.id"
              >
                <span
                  class="inline-flex items-center justify-center w-6 h-6 rounded-full border border-n-weak"
                >
                  <span
                    v-if="selectedConversationId === conversation.id"
                    class="w-3 h-3 rounded-full bg-woot-500"
                  />
                </span>
                <span class="font-medium text-n-slate-12">
                  #{{ conversation.id }}
                </span>
                <span class="text-xs text-n-slate-11 truncate">
                  {{
                    conversation.meta?.sender?.name ||
                    conversation.meta?.sender?.email ||
                    t('KANBAN.CONVERSATION_NO_CONTACT')
                  }}
                </span>
              </button>
            </div>
          </div>

          <div class="flex justify-between items-center gap-2 mt-2">
            <Button
              variant="ghost"
              color="blue"
              size="sm"
              :disabled="loadingConversations"
              @click="handleCreateNewConversation"
            >
              Nova conversa
            </Button>
            <div class="flex justify-end gap-2">
              <Button
                variant="ghost"
                color="slate"
                size="sm"
                @click="showLinkConversationModal = false"
              >
                {{ t('KANBAN.CANCEL') }}
              </Button>
              <Button
                variant="solid"
                color="blue"
                size="sm"
                :disabled="!selectedConversationId || loadingConversations"
                @click="confirmLinkConversation"
              >
                {{ t('KANBAN.BULK_ACTIONS.CONFIRM') }}
              </Button>
            </div>
          </div>
        </template>

        <!-- Modo 2: Criar nova conversa com contato selecionado -->
        <template v-else>
          <p class="text-sm text-n-slate-11">
            Selecione um contato para criar uma nova conversa e vinculá-la a
            este item.
          </p>

          <div class="space-y-2">
            <label class="text-xs font-medium text-n-slate-11">
              Buscar contato (nome, e-mail ou telefone)
            </label>
            <div class="flex gap-2">
              <input
                v-model="newConversationContactSearch"
                type="text"
                class="flex-1 px-3 py-2 border border-n-weak rounded-md text-sm bg-n-solid-2 focus:ring-2 focus:ring-woot-500/20 focus:border-woot-500"
                placeholder="Digite para buscar contatos..."
                @keyup.enter="searchNewConversationContacts"
              />
              <Button
                variant="solid"
                color="blue"
                size="sm"
                :is-loading="newConversationLoadingContacts"
                @click="searchNewConversationContacts"
              >
                Buscar
              </Button>
            </div>
          </div>

          <div
            class="border border-n-weak rounded-md max-h-56 overflow-y-auto mt-2"
          >
            <div
              v-if="newConversationLoadingContacts"
              class="flex items-center justify-center py-6 text-n-slate-10 text-sm"
            >
              Carregando contatos...
            </div>
            <div
              v-else-if="newConversationContacts.length === 0"
              class="flex items-center justify-center py-6 text-n-slate-10 text-sm"
            >
              Nenhum contato encontrado. Digite para buscar.
            </div>
            <div v-else class="divide-y divide-n-weak">
              <button
                v-for="contact in newConversationContacts"
                :key="contact.id"
                type="button"
                class="w-full px-3 py-2 flex items-center gap-2 text-left text-sm hover:bg-n-alpha-2 transition-colors"
                :class="{
                  'bg-woot-50 dark:bg-woot-900/30':
                    newConversationSelectedContact?.id === contact.id,
                }"
                @click="selectNewConversationContact(contact)"
              >
                <span class="font-medium text-n-slate-12">
                  {{ contact.name || 'Contato sem nome' }}
                </span>
                <span class="text-xs text-n-slate-11 truncate">
                  {{
                    contact.email ||
                    contact.phoneNumber ||
                    'Sem e-mail/telefone'
                  }}
                </span>
              </button>
            </div>
          </div>

          <div v-if="newConversationSelectedContact" class="mt-4 space-y-3">
            <p class="text-xs font-medium text-n-slate-11">
              Canais disponíveis para este contato
            </p>
            <div
              class="border border-n-weak rounded-md max-h-40 overflow-y-auto"
            >
              <div
                v-if="newConversationLoadingInboxes"
                class="flex items-center justify-center py-4 text-n-slate-10 text-sm"
              >
                Carregando canais...
              </div>
              <div
                v-else-if="newConversationInboxes.length === 0"
                class="flex items-center justify-center py-4 text-n-slate-10 text-sm"
              >
                Nenhum canal disponível para iniciar conversa com este contato.
              </div>
              <div v-else class="divide-y divide-n-weak">
                <button
                  v-for="inbox in newConversationInboxes"
                  :key="inbox.id"
                  type="button"
                  class="w-full px-3 py-2 flex items-center gap-2 text-left text-sm hover:bg-n-alpha-2 transition-colors"
                  :class="{
                    'bg-woot-50 dark:bg-woot-900/30':
                      newConversationSelectedInbox?.id === inbox.id,
                  }"
                  @click="newConversationSelectedInbox = inbox"
                >
                  <span
                    class="inline-flex items-center justify-center w-5 h-5 rounded-full border border-n-weak mr-1"
                  >
                    <span
                      v-if="newConversationSelectedInbox?.id === inbox.id"
                      class="w-2.5 h-2.5 rounded-full bg-woot-500"
                    />
                  </span>
                  <span class="font-medium text-n-slate-12">
                    {{ inbox.name }}
                  </span>
                  <span class="text-xs text-n-slate-11 truncate">
                    {{ inbox.channelType }}
                  </span>
                </button>
              </div>
            </div>

            <!-- Seleção de modelo de mensagem (agora logo acima da mensagem) -->
            <div class="space-y-2">
              <div class="flex items-center justify-between">
                <label class="text-xs font-medium text-n-slate-11">
                  Modelo de mensagem (opcional)
                </label>
                <span
                  v-if="loadingMessageTemplates"
                  class="text-[11px] text-n-slate-10"
                >
                  Carregando modelos...
                </span>
              </div>

              <div
                v-if="!loadingMessageTemplates && messageTemplates.length === 0"
                class="text-[11px] text-n-slate-10"
              >
                Nenhum modelo de mensagem configurado para esta etapa do funil.
              </div>

              <div
                v-else
                class="border border-n-weak rounded-md max-h-36 overflow-y-auto"
              >
                <button
                  v-for="template in messageTemplates"
                  :key="template.id"
                  type="button"
                  class="w-full px-3 py-2 flex items-start gap-2 text-left text-xs hover:bg-n-alpha-2 transition-colors"
                  :class="{
                    'bg-woot-50 dark:bg-woot-900/30':
                      selectedMessageTemplateId === template.id,
                  }"
                  @click="
                    () => {
                      selectedMessageTemplateId = template.id;
                      newConversationMessage = template.content || '';
                    }
                  "
                >
                  <span
                    class="inline-flex items-center justify-center w-4 h-4 mt-0.5 rounded-full border border-n-weak flex-shrink-0"
                  >
                    <span
                      v-if="selectedMessageTemplateId === template.id"
                      class="w-2.5 h-2.5 rounded-full bg-woot-500"
                    />
                  </span>
                  <div class="flex-1 min-w-0">
                    <div class="font-medium text-n-slate-12 truncate">
                      {{ template.title || 'Modelo sem título' }}
                    </div>
                    <div class="text-[11px] text-n-slate-11 line-clamp-2">
                      {{ template.content }}
                    </div>
                  </div>
                </button>
              </div>
            </div>

            <div class="space-y-2">
              <label class="text-xs font-medium text-n-slate-11">
                Mensagem inicial (pode ser ajustada mesmo após escolher um
                modelo)
              </label>
              <textarea
                v-model="newConversationMessage"
                rows="3"
                class="w-full px-3 py-2 border border-n-weak rounded-md text-sm bg-n-solid-2 focus:ring-2 focus:ring-woot-500/20 focus:border-woot-500"
                placeholder="Digite uma mensagem para iniciar a conversa..."
              />
            </div>
          </div>

          <div class="flex justify-between items-center gap-2 mt-4">
            <Button
              variant="ghost"
              color="slate"
              size="sm"
              @click="isNewConversationMode = false"
            >
              Voltar para lista de conversas
            </Button>
            <div class="flex justify-end gap-2">
              <Button
                variant="ghost"
                color="slate"
                size="sm"
                @click="
                  () => {
                    showLinkConversationModal = false;
                    resetNewConversationState();
                  }
                "
              >
                {{ t('KANBAN.CANCEL') }}
              </Button>
              <Button
                variant="solid"
                color="blue"
                size="sm"
                :is-loading="newConversationCreating"
                :disabled="
                  !newConversationSelectedContact ||
                  !newConversationSelectedInbox ||
                  newConversationCreating
                "
                @click="createNewConversationFromKanban"
              >
                Criar e vincular
              </Button>
            </div>
          </div>
        </template>
      </div>
    </div>
  </Modal>

  <!-- Modal de Confirmação de Exclusão -->
  <Modal
    v-if="isItemVisible"
    v-model:show="showDeleteModal"
    :on-close="
      () => {
        showDeleteModal = false;
        itemToDelete = null;
      }
    "
  >
    <div class="p-6">
      <h3 class="text-lg font-medium mb-4">
        {{ t('KANBAN.DELETE_CONFIRMATION.TITLE') }}
      </h3>
      <p class="text-sm text-n-slate-11 mb-6">
        {{
          t('KANBAN.DELETE_CONFIRMATION.MESSAGE', { item: itemToDeleteName })
        }}
      </p>
      <div class="flex justify-end space-x-2">
        <Button variant="faded" color="slate" @click="showDeleteModal = false">
          {{ t('KANBAN.CANCEL') }}
        </Button>
        <Button variant="solid" color="ruby" @click="confirmDelete">
          {{ t('KANBAN.DELETE') }}
        </Button>
      </div>
    </div>
  </Modal>

  <!-- Modal de Status -->
  <Modal
    v-if="isItemVisible"
    v-model:show="showStatusModal"
    :on-close="() => (showStatusModal = false)"
    :show-close-button="true"
    size="small"
  >
    <div class="p-4 bg-n-solid-1 rounded-md border border-n-weak shadow-lg">
      <h3 class="text-lg font-medium mb-4">Atualizar status</h3>
      <div
        v-if="isLossReasonRequired && statusForm.status === 'lost'"
        class="p-2 mb-4 rounded-md border border-n-ruby-6 bg-n-ruby-2"
      >
        <p class="text-[11px] font-medium text-n-ruby-11">
          <span class="i-ri-information-line size-3 mr-1 inline-block" />
          {{ t('KANBAN.FORM.LOSS_REASON_MANDATORY') }}
        </p>
      </div>
      <div class="space-y-4">
        <div class="flex gap-2">
          <button
            class="flex-1 px-3 py-1.5 border rounded-md text-xs font-normal transition-colors hover:bg-n-alpha-2"
            :class="
              statusForm.status === 'open'
                ? 'border-n-strong bg-n-solid-2 font-bold text-n-slate-12'
                : 'border-n-weak'
            "
            @click="statusForm.status = 'open'"
          >
            <span class="truncate">Em aberto</span>
            <span
              v-if="statusForm.status === 'open'"
              class="ml-2 text-woot-500 text-xs font-semibold"
              >Selecionado</span
            >
          </button>
          <button
            class="flex-1 px-3 py-1.5 border rounded-md text-xs font-normal transition-colors hover:bg-green-50 dark:hover:bg-green-900"
            :class="
              statusForm.status === 'won'
                ? 'border-green-500 bg-green-50 dark:bg-green-900 font-bold text-green-700 dark:text-green-100'
                : 'border-n-weak'
            "
            @click="statusForm.status = 'won'"
          >
            <span class="truncate">Ganho</span>
            <span
              v-if="statusForm.status === 'won'"
              class="ml-2 text-woot-500 text-xs font-semibold"
              >Selecionado</span
            >
          </button>
          <button
            class="flex-1 px-3 py-1.5 border rounded-md text-xs font-normal transition-colors hover:bg-red-50 dark:hover:bg-red-900"
            :class="
              statusForm.status === 'lost'
                ? 'border-red-500 bg-red-50 dark:bg-red-900 font-bold text-red-700 dark:text-red-100'
                : 'border-n-weak'
            "
            @click="statusForm.status = 'lost'"
          >
            <span class="truncate">Perdido</span>
            <span
              v-if="statusForm.status === 'lost'"
              class="ml-2 text-woot-500 text-xs font-semibold"
              >Selecionado</span
            >
          </button>
        </div>
        <div v-if="statusForm.status === 'lost'" class="space-y-2">
          <div v-if="lossReasons.length > 0" class="space-y-2">
            <label class="text-sm font-medium">Motivo da perda</label>
            <select
              v-model="statusForm.selectedLossReason"
              class="w-full p-2 border border-n-weak rounded-md text-xs bg-n-solid-2 focus:ring-2 focus:ring-woot-500/20 focus:border-woot-500"
            >
              <option :value="null">Selecione um motivo</option>
              <option
                v-for="reason in lossReasons"
                :key="reason.id"
                :value="reason.id"
              >
                {{ reason.title }}
              </option>
              <option value="other">Outro</option>
            </select>
          </div>
          <div
            v-if="
              statusForm.selectedLossReason === 'other' || !lossReasons.length
            "
            class="space-y-2"
          >
            <label class="text-sm font-medium">{{
              lossReasons.length > 0
                ? 'Descreva o motivo'
                : 'Observações adicionais'
            }}</label>
            <textarea
              v-model="statusForm.reason"
              class="w-full p-2 border border-n-weak rounded-md text-xs bg-n-solid-2 focus:ring-2 focus:ring-woot-500/20 focus:border-woot-500"
              rows="3"
              :placeholder="
                lossReasons.length > 0
                  ? 'Descreva o motivo da perda'
                  : 'Descreva detalhes adicionais (opcional)'
              "
            />
          </div>
        </div>
        <div v-if="statusForm.status === 'won'" class="space-y-2">
          <div v-if="winReasons.length > 0" class="space-y-2">
            <label class="text-sm font-medium">Motivo do ganho</label>
            <select
              v-model="statusForm.selectedWinReason"
              class="w-full p-2 border border-n-weak rounded-md text-xs bg-n-solid-2 focus:ring-2 focus:ring-woot-500/20 focus:border-woot-500"
            >
              <option :value="null">Selecione um motivo</option>
              <option
                v-for="reason in winReasons"
                :key="reason.id"
                :value="reason.id"
              >
                {{ reason.title }}
              </option>
              <option value="other">Outro</option>
            </select>
          </div>
          <div
            v-if="statusForm.selectedWinReason === 'other'"
            class="space-y-2"
          >
            <label class="text-sm font-medium">Descreva o motivo</label>
            <textarea
              v-model="statusForm.reason"
              class="w-full p-2 border border-n-weak rounded-md text-xs bg-n-solid-2 focus:ring-2 focus:ring-woot-500/20 focus:border-woot-500"
              rows="3"
              placeholder="Descreva o motivo do ganho"
            />
          </div>
        </div>
        <div v-if="statusForm.status === 'won'" class="space-y-2">
          <label class="text-sm font-medium">Oferta ganhadora do item</label>
          <div
            v-if="availableOffers.length > 0"
            class="space-y-2 max-h-40 overflow-y-auto"
          >
            <button
              v-for="(offer, index) in availableOffers"
              :key="index"
              type="button"
              class="flex items-center w-full px-3 py-2 rounded-md transition-colors gap-3 border border-n-weak text-xs font-normal hover:bg-n-alpha-2"
              :class="[
                statusForm.selectedOffer === offer
                  ? 'border-green-500 bg-green-50 dark:bg-green-900/30 font-bold text-green-700 dark:text-green-300'
                  : '',
              ]"
              @click="statusForm.selectedOffer = offer"
            >
              <div class="flex flex-col items-start flex-1 min-w-0">
                <div class="flex items-center gap-2 w-full">
                  <span class="font-medium truncate">{{
                    offer.description || 'Oferta sem descrição'
                  }}</span>
                  <span
                    class="text-green-600 dark:text-green-400 font-semibold text-xs"
                  >
                    {{ formatKanbanCurrency(offer.value || 0, offer.currency) }}
                  </span>
                </div>
              </div>
              <span
                v-if="statusForm.selectedOffer === offer"
                class="text-green-500 text-xs font-semibold flex-shrink-0"
                >Selecionada</span
              >
            </button>
          </div>
          <div
            v-else
            class="px-3 py-2 text-n-slate-10 text-xs rounded-md bg-n-solid-2/50"
          >
            O item não possui ofertas. Edite o item e adicione ofertas na aba
            Ofertas para poder escolher a ganhadora.
          </div>
        </div>
        <div class="flex justify-end gap-2 mt-4">
          <Button
            variant="ghost"
            color="slate"
            size="sm"
            @click="showStatusModal = false"
          >
            Cancelar
          </Button>
          <Button
            variant="solid"
            color="blue"
            size="sm"
            :disabled="
              (statusForm.status === 'won' &&
                availableOffers.length > 0 &&
                !statusForm.selectedOffer) ||
              isReasonMissing
            "
            @click="handleStatusSave"
          >
            Salvar
          </Button>
        </div>
      </div>
    </div>
  </Modal>

  <!-- Modal de Visibilidade dos Campos -->
  <Modal
    v-if="isItemVisible"
    v-model:show="showVisibilityModal"
    :on-close="() => (showVisibilityModal = false)"
    :show-close-button="true"
    size="medium"
  >
    <div class="settings-modal">
      <header class="settings-header">
        <h3 class="text-lg font-medium">
          {{ t('KANBAN.CONTEXT_MENU.CUSTOMIZE_FIELDS.TITLE') }}
        </h3>
      </header>
      <div class="settings-content">
        <p class="text-sm text-n-slate-11 mb-4">
          {{ t('KANBAN.CONTEXT_MENU.CUSTOMIZE_FIELDS.DESCRIPTION') }}
        </p>

        <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
          <!-- Coluna 1 -->
          <div class="space-y-4">
            <label
              class="flex items-center p-2 rounded hover:bg-n-alpha-2 cursor-pointer transition-colors"
            >
              <input
                v-model="showDescriptionField"
                type="checkbox"
                class="form-checkbox h-4 w-4 text-woot-500"
              />
              <span class="ml-2 text-sm">
                <span class="font-medium">{{
                  t('KANBAN.FORM.DESCRIPTION.LABEL')
                }}</span>
                <span
                  class="inline-block ml-2 px-2.5 py-1 text-[10px] font-semibold bg-indigo-100 text-indigo-700 dark:bg-indigo-800 dark:text-indigo-100 rounded-md border border-indigo-200 dark:border-indigo-700"
                  >{{
                    t(
                      'KANBAN.CONTEXT_MENU.CUSTOMIZE_FIELDS.VISIBLE_WHEN_COLLAPSED'
                    )
                  }}</span
                >
                <span class="block text-xs text-n-slate-11"
                  >Detalhes do card</span
                >
              </span>
            </label>

            <label
              class="flex items-center p-2 rounded hover:bg-n-alpha-2 cursor-pointer transition-colors"
            >
              <input
                v-model="showLabelsField"
                type="checkbox"
                class="form-checkbox h-4 w-4 text-woot-500"
              />
              <span class="ml-2 text-sm">
                <span class="font-medium">Etiquetas</span>
                <span class="block text-xs text-n-slate-11"
                  >Tags da conversa</span
                >
              </span>
            </label>

            <label
              class="flex items-center p-2 rounded hover:bg-n-alpha-2 cursor-pointer transition-colors"
            >
              <input
                v-model="showPriorityField"
                type="checkbox"
                class="form-checkbox h-4 w-4 text-woot-500"
              />
              <span class="ml-2 text-sm">
                <span class="font-medium">{{
                  t('KANBAN.FORM.PRIORITY.LABEL')
                }}</span>
                <span class="block text-xs text-n-slate-11"
                  >{{ t('KANBAN.PRIORITY_LABELS.HIGH') }},
                  {{ t('KANBAN.PRIORITY_LABELS.MEDIUM') }},
                  {{ t('KANBAN.PRIORITY_LABELS.LOW') }}</span
                >
              </span>
            </label>

            <label
              class="flex items-center p-2 rounded hover:bg-n-alpha-2 cursor-pointer transition-colors"
            >
              <input
                v-model="showValueField"
                type="checkbox"
                class="form-checkbox h-4 w-4 text-woot-500"
              />
              <span class="ml-2 text-sm">
                <span class="font-medium">{{
                  t('KANBAN.FORM.VALUE.LABEL')
                }}</span>
                <span class="block text-xs text-n-slate-11">{{
                  t('KANBAN.FORM.VALUE.LABEL')
                }}</span>
              </span>
            </label>
          </div>

          <!-- Coluna 2 -->
          <div class="space-y-4">
            <label
              class="flex items-center p-2 rounded hover:bg-n-alpha-2 cursor-pointer transition-colors"
            >
              <input
                v-model="showDeadlineField"
                type="checkbox"
                class="form-checkbox h-4 w-4 text-woot-500"
              />
              <span class="ml-2 text-sm">
                <span class="font-medium">{{ t('KANBAN.DEADLINE') }}</span>
                <span class="block text-xs text-n-slate-11">{{
                  t('KANBAN.DEADLINE_DESCRIPTION')
                }}</span>
              </span>
            </label>

            <label
              class="flex items-center p-2 rounded hover:bg-n-alpha-2 cursor-pointer transition-colors"
            >
              <input
                v-model="showConversationField"
                type="checkbox"
                class="form-checkbox h-4 w-4 text-woot-500"
              />
              <span class="ml-2 text-sm">
                <span class="font-medium">{{
                  t('KANBAN.ITEM_CONVERSATION.TITLE')
                }}</span>
                <span class="block text-xs text-n-slate-11">{{
                  t('KANBAN.ITEM_CONVERSATION.DESCRIPTION')
                }}</span>
              </span>
            </label>

            <label
              class="flex items-center p-2 rounded hover:bg-n-alpha-2 cursor-pointer transition-colors"
            >
              <input
                v-model="showChecklistField"
                type="checkbox"
                class="form-checkbox h-4 w-4 text-woot-500"
              />
              <span class="ml-2 text-sm">
                <span class="font-medium">Checklist</span>
                <span class="block text-xs text-n-slate-11"
                  >Progresso das tarefas</span
                >
              </span>
            </label>

            <label
              class="flex items-center p-2 rounded hover:bg-n-alpha-2 cursor-pointer transition-colors"
            >
              <input
                v-model="showAgentField"
                type="checkbox"
                class="form-checkbox h-4 w-4 text-woot-500"
              />
              <span class="ml-2 text-sm">
                <span class="font-medium">Agente</span>
                <span class="block text-xs text-n-slate-11"
                  >Responsável atribuído</span
                >
              </span>
            </label>
          </div>
        </div>

        <div class="mt-4 pt-4 border-t border-n-weak">
          <label
            class="flex items-center p-2 rounded hover:bg-n-alpha-2 cursor-pointer transition-colors"
          >
            <input
              v-model="showMetadataField"
              type="checkbox"
              class="form-checkbox h-4 w-4 text-woot-500"
            />
            <span class="ml-2 text-sm">
              <span class="font-medium">Metadados</span>
              <span class="block text-xs text-n-slate-11"
                >Tempo na etapa, anexos e notas</span
              >
            </span>
          </label>
        </div>

        <div class="flex justify-between mt-6">
          <Button
            variant="ghost"
            color="slate"
            size="sm"
            @click="
              () => {
                showDescriptionField = true;
                showLabelsField = true;
                showPriorityField = true;
                showValueField = true;
                showDeadlineField = true;
                showConversationField = true;
                showChecklistField = true;
                showAgentField = true;
                showMetadataField = true;
              }
            "
          >
            Restaurar padrão
          </Button>
          <Button
            variant="solid"
            color="blue"
            size="sm"
            @click="showVisibilityModal = false"
          >
            Fechar
          </Button>
        </div>
      </div>
    </div>
  </Modal>

  <!-- Modal de atribuição rápida de agente -->
  <Modal
    v-model:show="showAgentAssignModal"
    :on-close="() => (showAgentAssignModal = false)"
    :show-close-button="true"
    size="medium"
  >
    <div class="p-4 bg-n-solid-1 rounded-md border border-n-weak shadow-lg">
      <h3 class="text-lg font-medium mb-4">Gerenciar Agentes Atribuídos</h3>

      <!-- Seção de agentes já atribuídos -->
      <div v-if="agentInfo.length > 0" class="mb-4">
        <h4 class="text-sm font-medium text-n-slate-12 mb-2">
          Agentes Atribuídos ({{ agentInfo.length }})
        </h4>
        <div class="space-y-2">
          <div
            v-for="agent in agentInfo"
            :key="agent.id"
            class="flex items-center justify-between p-2 bg-n-solid-2 rounded-md"
          >
            <div class="flex items-center gap-2">
              <Avatar
                :name="agent.name"
                :src="agent.avatar_url || agent.thumbnail || ''"
                :size="24"
              />
              <div>
                <div class="text-sm font-medium text-n-slate-12">
                  {{ agent.name }}
                </div>
                <div class="text-xs text-n-slate-11">
                  Atribuído em
                  {{ new Date(agent.assigned_at).toLocaleDateString('pt-BR') }}
                </div>
              </div>
            </div>
            <button
              class="p-1 text-n-slate-10 hover:text-red-500 transition-colors"
              @click="removeAgent(agent.id)"
            >
              <span class="i-ri-delete-bin-line size-4" />
            </button>
          </div>
        </div>
      </div>

      <!-- Seção para adicionar novos agentes -->
      <div class="border-t border-n-weak pt-4">
        <h4 class="text-sm font-medium text-n-slate-12 mb-2">
          Adicionar Novo Agente
        </h4>
        <input
          v-model="agentSearch"
          type="text"
          class="w-full mb-3 px-3 py-2 border border-n-weak rounded-md text-xs bg-n-solid-2 focus:ring-2 focus:ring-woot-500/20 focus:border-woot-500"
          placeholder="Buscar agentes..."
        />
        <div class="space-y-2 mb-4 max-h-40 overflow-y-auto">
          <button
            v-for="agent in filteredAgentList"
            :key="agent.id"
            type="button"
            class="flex items-center w-full px-3 py-1.5 rounded-md transition-colors gap-2 border border-n-weak text-xs font-normal hover:bg-n-alpha-2"
            :class="[
              selectedAgentId === agent.id
                ? 'border-woot-500 bg-woot-50 dark:bg-woot-900/30 font-bold text-woot-600'
                : '',
              agentInfo.some(a => a.id === agent.id)
                ? 'opacity-50 cursor-not-allowed'
                : '',
            ]"
            :disabled="agentInfo.some(a => a.id === agent.id)"
            @click="selectedAgentId = agent.id"
          >
            <Avatar
              :name="agent.name || 'Agente'"
              :src="agent.avatar_url || agent.thumbnail || ''"
              :size="24"
              class="mr-2"
            />
            <span class="truncate">{{ agent.name || 'Agente' }}</span>
            <span
              v-if="agentInfo.some(a => a.id === agent.id)"
              class="ml-auto text-n-slate-10 text-xs"
              >Já atribuído</span
            >
            <span
              v-else-if="selectedAgentId === agent.id"
              class="ml-auto text-woot-500 text-xs font-semibold"
              >Selecionado</span
            >
          </button>
          <div
            v-if="filteredAgentList.length === 0"
            class="px-3 py-2 text-n-slate-10 text-xs"
          >
            Nenhum agente encontrado
          </div>
        </div>
      </div>

      <div class="flex justify-end gap-2 mt-4">
        <Button
          variant="ghost"
          color="slate"
          size="sm"
          @click="showAgentAssignModal = false"
        >
          Fechar
        </Button>
        <Button
          variant="solid"
          color="blue"
          size="sm"
          :is-loading="agentAssignLoading"
          :disabled="
            !selectedAgentId ||
            agentAssignLoading ||
            agentInfo.some(a => a.id === selectedAgentId)
          "
          @click="assignAgent"
        >
          Adicionar Agente
        </Button>
      </div>
    </div>
  </Modal>

  <!-- Modal de seleção de prioridade -->
  <Modal
    v-model:show="showPriorityModal"
    :on-close="() => (showPriorityModal = false)"
    :show-close-button="true"
    size="small"
  >
    <div class="p-4 bg-n-solid-1 rounded-md border border-n-weak shadow-lg">
      <h3 class="text-lg font-medium mb-4">Definir prioridade</h3>
      <div class="space-y-2 mb-4">
        <button
          v-for="option in [
            { value: 'urgent', label: 'Urgente' },
            { value: 'high', label: 'Alta' },
            { value: 'medium', label: 'Média' },
            { value: 'low', label: 'Baixa' },
            { value: 'none', label: 'Nenhuma' },
          ]"
          :key="option.value"
          type="button"
          class="flex items-center w-full px-3 py-1.5 rounded-md transition-colors gap-2 border border-n-weak text-xs font-normal hover:bg-n-alpha-2"
          :class="[
            selectedPriority === option.value
              ? 'border-woot-500 bg-woot-50 dark:bg-woot-900/30 font-bold text-woot-600'
              : '',
          ]"
          @click="selectedPriority = option.value"
        >
          <span class="truncate">{{ option.label }}</span>
          <span
            v-if="selectedPriority === option.value"
            class="ml-auto text-woot-500 text-xs font-semibold"
            >Selecionado</span
          >
        </button>
      </div>
      <div class="flex justify-end gap-2 mt-4">
        <Button
          variant="ghost"
          color="slate"
          size="sm"
          @click="showPriorityModal = false"
        >
          Cancelar
        </Button>
        <Button
          variant="solid"
          color="blue"
          size="sm"
          :is-loading="priorityAssignLoading"
          :disabled="priorityAssignLoading"
          @click="assignPriority"
        >
          Confirmar
        </Button>
      </div>
    </div>
  </Modal>

</template>

<style lang="scss" scoped>
.flex {
  &:first-child {
    margin-top: 0;
  }
}

.settings-modal {
  @apply flex flex-col;

  .settings-header {
    @apply p-4 border-b border-n-weak;
  }

  .settings-content {
    @apply p-4 space-y-4;
  }
}

// Garantir alinhamento correto entre avatar e priority circle
:deep(.avatar-component) {
  display: flex;
  align-items: center;
  justify-content: center;
}

:deep(.priority-circle) {
  display: flex;
  align-items: center;
  justify-content: center;
}

// Estilos para markdown renderizado
.prose {
  font-size: 12px !important;
  @apply leading-relaxed;

  :deep(p) {
    @apply mb-1 last:mb-0;
    font-size: 12px !important;
  }

  :deep(ul) {
    @apply list-disc list-inside mb-1 space-y-1;
  }

  :deep(ol) {
    @apply list-decimal list-inside mb-1 space-y-1;
  }

  :deep(li) {
    @apply leading-relaxed;
    font-size: 12px !important;
  }

  :deep(strong) {
    @apply font-semibold;
    font-size: 12px !important;
  }

  :deep(em) {
    @apply italic;
    font-size: 12px !important;
  }

  :deep(code) {
    @apply bg-n-solid-2 px-1 py-0.5 rounded font-mono;
    font-size: 12px !important;
  }

  :deep(pre) {
    @apply bg-n-solid-2 p-2 rounded font-mono overflow-x-auto mb-1;
    font-size: 12px !important;
  }

  :deep(a) {
    @apply text-woot-500 hover:text-woot-600 underline;
    font-size: 12px !important;
  }
}
</style>
